var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlockchianWallets(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 950.103,
    height: 550.989,
    viewBox: "0 0 950.103 550.989",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_172",
    x: 751.97,
    y: 179.46,
    width: 198.133,
    height: 198.132,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_171",
    x: 0,
    y: 164.823,
    width: 197,
    height: 197,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_171-2",
    x: 408.272,
    y: 388.989,
    width: 162,
    height: 162,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_173",
    x: 400.027,
    y: 0,
    width: 154.446,
    height: 154.446,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_170",
    x: 147.637,
    y: 108.152,
    width: 179.157,
    height: 179.157,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_231",
    x: 34.757,
    y: 330.823,
    width: 84.423,
    height: 84.423,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-6"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_172-2",
    x: 565.796,
    y: 94.953,
    width: 116.696,
    height: 116.696,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-7"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_172-3",
    x: 518.949,
    y: 24.582,
    width: 116.696,
    height: 116.696,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-8"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-8"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_173-2",
    x: 308.715,
    y: 15.719,
    width: 123.007,
    height: 123.007,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-9"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_173-3",
    x: 162.12,
    y: 221.88,
    width: 105.353,
    height: 105.353,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-10"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-10"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_173-4",
    x: 283.564,
    y: 386.107,
    width: 139.462,
    height: 139.462,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-11"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-11"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_173-5",
    x: 103.888,
    y: 296.361,
    width: 139.462,
    height: 139.462,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-12"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-12"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_173-6",
    x: 721.258,
    y: 323.249,
    width: 155.48,
    height: 155.48,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-13"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-13"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_173-7",
    x: 364.499,
    y: 307.137,
    width: 155.48,
    height: 155.48,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-14"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-14"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_173-8",
    x: 533.586,
    y: 309.326,
    width: 210.672,
    height: 210.672,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-15"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-15"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_171-3",
    x: 254.972,
    y: 91.323,
    width: 197,
    height: 197,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-16"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-16"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_171-4",
    x: 216.473,
    y: 248.823,
    width: 187,
    height: 187,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-17"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-17"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_172-4",
    x: 546.125,
    y: 167.323,
    width: 198.133,
    height: 198.132,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-18"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-18"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_172-5",
    x: 104.783,
    y: 126.147,
    width: 84.337,
    height: 84.337,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-19"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-19"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_172-6",
    x: 252.896,
    y: 56.941,
    width: 84.337,
    height: 84.337,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-20"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-20"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_231-2",
    x: 191.472,
    y: 373.377,
    width: 84.423,
    height: 84.423,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-21"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-21"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_231-3",
    x: 465.751,
    y: 300.096,
    width: 119.435,
    height: 119.435,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-22"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-22"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_231-4",
    x: 369.315,
    y: 87.566,
    width: 84.424,
    height: 84.423,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-23"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-23"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_173-9",
    x: 477.772,
    y: 84.971,
    width: 105.353,
    height: 105.353,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-24"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-24"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_172-7",
    x: 670.656,
    y: 88.36,
    width: 159.91,
    height: 159.91,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-25"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-25"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_173-10",
    x: 629.48,
    y: 52.647,
    width: 105.353,
    height: 105.353,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-26"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-26"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_231-5",
    x: 721.258,
    y: 190.4,
    width: 84.424,
    height: 84.423,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-27"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-27"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_172-8",
    x: 682.341,
    y: 263.057,
    width: 136.539,
    height: 136.539,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-28"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-28"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2037",
    "data-name": "Group 2037",
    transform: "translate(15574.604 7.323)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2016",
    "data-name": "Group 2016",
    transform: "translate(-14811.133 180.637)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -763.47, -187.96)",
    filter: "url(#Ellipse_172)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_172-9",
    "data-name": "Ellipse 172",
    cx: 87.566,
    cy: 87.566,
    rx: 87.566,
    ry: 87.566,
    transform: "translate(763.47 187.96)",
    fill: "#2f8bf7",
    stroke: "#fff",
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2049",
    "data-name": "Group 2049",
    transform: "translate(-2457.352 -2481.926)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2339",
    "data-name": "Path 2339",
    d: "M2544.945,2633.771a61.257,61.257,0,1,1,61.231-61.21A61.3,61.3,0,0,1,2544.945,2633.771Zm6.538-43.486,13.945-16.713,27.375,32.835c15.929-21.878,15.138-55.517-8.1-77.141-22.176-20.633-57.729-20.528-79.685.084-22.068,20.719-21.632,50.009-14.34,64.993l31.92-43.286Zm38.853,19.563H2499.47c12.855,14.646,28.642,22.027,47.817,21.323C2564.607,2630.534,2578.81,2623.162,2590.336,2609.847Zm-69.078-52.771-28.545,38.727h28.545Zm2.694,38.821h1.827c5.932,0,11.868-.123,17.794.058,2.368.073,4.017-.531,5.354-2.5.63-.93.752-1.445.058-2.382q-11.988-16.17-23.9-32.4c-.288-.392-.621-.752-1.137-1.373Zm20.7,2.594h-52.665c1.875,2.973,3.556,5.687,5.313,8.351.187.283.817.385,1.241.386q18.893.03,37.786,0a1.874,1.874,0,0,0,1.273-.348C2539.925,2604.183,2542.194,2601.43,2544.649,2598.491Zm19.484-19.471-23.409,28.094h23.409Zm26.028,28.129c-7.848-9.417-15.483-18.576-23.339-28v28.1c7.511,0,14.892,0,22.272,0C2589.337,2607.24,2589.58,2607.2,2590.161,2607.149Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2340",
    "data-name": "Path 2340",
    d: "M2597.961,2547.194a16.247,16.247,0,1,1-16.278,16.245A16.244,16.244,0,0,1,2597.961,2547.194Zm-13.775,16.272a13.735,13.735,0,1,0,13.63-13.77A13.752,13.752,0,0,0,2584.186,2563.466Z",
    transform: "translate(-32.479 -11.908)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2341",
    "data-name": "Path 2341",
    d: "M2544.763,2533.7a8.747,8.747,0,1,1-8.745,8.746A8.762,8.762,0,0,1,2544.763,2533.7Zm6.246,8.688a6.246,6.246,0,1,0-6.188,6.306A6.26,6.26,0,0,0,2551.009,2542.383Z",
    transform: "translate(-17.348 -7.435)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2008",
    "data-name": "Group 2008",
    transform: "translate(-15559.835 169.084)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -14.77, -176.41)",
    filter: "url(#Ellipse_171)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_171-5",
    "data-name": "Ellipse 171",
    cx: 84.5,
    cy: 84.5,
    r: 84.5,
    transform: "translate(14 175.82)",
    fill: "#2f8bf7",
    stroke: "#fff",
    strokeWidth: 10
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2058",
    "data-name": "Group 2058",
    transform: "translate(-109.259 448.206)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2388",
    "data-name": "Path 2388",
    d: "M191.27-424.317a25.666,25.666,0,0,1,6.578,7.095,55.892,55.892,0,0,1,8.939,26.142,26.319,26.319,0,0,1-4.036,16.6c-3.845,6.313-8.7,11.869-13.144,17.732-3.76,4.961-7.282,10.058-9.511,15.932-3.019,7.956-1.7,15.656,1.358,23.255a96.738,96.738,0,0,0,5.3,10.228c.427.781,1.273,1.688.6,2.57-.663.864-1.761.392-2.643.153-15.468-4.2-25.083-14.482-29.324-29.562-4.032-14.338.723-26.729,10.273-37.542,3.13-3.544,6.532-6.847,9.784-10.286,9.949-10.519,14.853-23.138,15.567-37.495C191.081-420.966,191.167-422.438,191.27-424.317Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2389",
    "data-name": "Path 2389",
    d: "M292.546-271.6c-.456,13.8-7.082,25.25-20.291,32.785a12.465,12.465,0,0,0-4.853,4.187c-.847,1.417-1.38,1.1-2.335.082-9.7-10.344-11.444-22.047-6.136-35.009a81.172,81.172,0,0,1,7.745-14.184,87.306,87.306,0,0,0,9.374-17.429c.465-1.232.251-3.4,1.3-3.538,1.309-.173,2.285,1.639,3.284,2.7C288.31-293.839,292.37-284.186,292.546-271.6Z",
    transform: "translate(-60.507 -70.923)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2009",
    "data-name": "Group 2009",
    transform: "translate(-15153.563 391.25)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -421.04, -398.57)",
    filter: "url(#Ellipse_171-2)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_171-6",
    "data-name": "Ellipse 171",
    cx: 69,
    cy: 69,
    r: 69,
    transform: "translate(420.27 397.99)",
    fill: "#2f8bf7",
    stroke: "#fff",
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2054",
    "data-name": "Group 2054",
    transform: "translate(92.746 -482.583)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2358",
    "data-name": "Path 2358",
    d: "M-3.661,539.738l3.911-.872c.751-.167,1.5-.323,2.253-.5.2-.048.267.01.316.191q.642,2.35,1.3,4.7c.06.214-.012.279-.2.33-1.553.406-3.1.821-4.654,1.234L-11.247,547.6c-.073.019-.147.032-.218.058-.21.076-.258-.045-.294-.216-.184-.872-.374-1.743-.562-2.614q-1.425-6.632-2.854-13.263c-.052-.242-.01-.351.25-.407q2.09-.455,4.173-.943c.283-.066.334.072.385.288q.821,3.48,1.652,6.958a.753.753,0,0,0,.145.317c.177-.395.375-.782.528-1.186a13.317,13.317,0,0,0,.873-4.2,12.5,12.5,0,0,0-2.966-8.649,11.55,11.55,0,0,0-4.141-3.382,12.153,12.153,0,0,0-2.951-.811,15.64,15.64,0,0,0-3.413-.319,12.1,12.1,0,0,0-6.23,1.986,12.032,12.032,0,0,0-4.969,7.127,18.851,18.851,0,0,0-.419,2.8,10.9,10.9,0,0,0,.2,3.472,11.736,11.736,0,0,0,2.213,4.737,25.187,25.187,0,0,0,4.635,4.555.885.885,0,0,0,.177.139c.617.267.617.773.557,1.334-.076.718-.109,1.441-.158,2.162-.074,1.066-.146,2.131-.223,3.261-.127-.072-.207-.107-.276-.157a61.532,61.532,0,0,1-8.021-6.834,16.818,16.818,0,0,1-4.059-7.658,15.43,15.43,0,0,1-.493-4.352,19.125,19.125,0,0,1,1.611-7.011,17.657,17.657,0,0,1,4.056-6.011,17.5,17.5,0,0,1,7.614-4.217,18.865,18.865,0,0,1,4.185-.682c1.135-.044,2.273-.089,3.406-.046a11.375,11.375,0,0,1,3.994,1.008,18.088,18.088,0,0,1,8.311,6.823,15.989,15.989,0,0,1,2.476,6.711,20.252,20.252,0,0,1-.817,8.928C-3.119,538.108-3.385,538.9-3.661,539.738Z",
    transform: "translate(-4.993 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2359",
    "data-name": "Path 2359",
    d: "M-35.567,598.113a13.011,13.011,0,0,0-1.246,3.165,12.31,12.31,0,0,0-.366,3.855,12.608,12.608,0,0,0,2.066,6.157,13.369,13.369,0,0,0,4.187,4.162,9.491,9.491,0,0,0,3.229,1.128,27.248,27.248,0,0,0,2.747.444,10.807,10.807,0,0,0,3.166-.221,11.429,11.429,0,0,0,6.445-3.629,12.74,12.74,0,0,0,3.056-6.311,15.414,15.414,0,0,0,.2-3.762,11.012,11.012,0,0,0-1.5-4.8,19.928,19.928,0,0,0-3.942-4.69c-.6-.552-1.236-1.072-1.865-1.595a.453.453,0,0,1-.18-.438q.224-2.225.441-4.452c.042-.429.078-.86.119-1.289.007-.07.024-.14.044-.256a3.328,3.328,0,0,1,.283.176,66.193,66.193,0,0,1,7.512,6.694,16.9,16.9,0,0,1,4.115,8.028,15.718,15.718,0,0,1,.388,4.476A18.794,18.794,0,0,1-8.24,611.4a18.006,18.006,0,0,1-4,5.984,17.709,17.709,0,0,1-8.794,4.555,25.766,25.766,0,0,1-6.167.445,13.5,13.5,0,0,1-6.239-1.923,17.534,17.534,0,0,1-7.547-7.981,16,16,0,0,1-1.389-5,20.708,20.708,0,0,1,1.28-9.682c.206-.553.41-1.107.631-1.7l-2.121.406c-1.344.259-2.691.509-4.032.785-.26.054-.328-.031-.381-.25-.258-1.068-.527-2.132-.791-3.2-.115-.465-.214-.934-.35-1.393-.075-.254-.008-.35.241-.408q2.674-.619,5.345-1.257,4.794-1.136,9.588-2.276c.164-.039.333-.066.492-.119.2-.064.276.012.311.2q.366,1.978.737,3.955.662,3.526,1.324,7.053c.316,1.687.627,3.375.949,5.062.033.178,0,.258-.182.294-1.427.278-2.854.555-4.277.853-.272.057-.341-.036-.389-.271q-.508-2.482-1.033-4.96C-35.208,599.782-35.381,598.986-35.567,598.113Z",
    transform: "translate(0 -34.236)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2360",
    "data-name": "Path 2360",
    d: "M-2.367,564.032v22.885a2.3,2.3,0,0,0,0,.282c.033.278-.068.381-.361.374-.827-.018-1.655-.006-2.483-.006-.7,0-1.392-.006-2.088,0-.22,0-.314-.076-.3-.293.005-.084,0-.169,0-.254V541.057c0-.556,0-.556.545-.556h4.261c.422,0,.423,0,.423.421Q-2.367,552.477-2.367,564.032Z",
    transform: "translate(-19.358 -12.727)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2022",
    "data-name": "Group 2022",
    transform: "translate(-15162.986 1.472)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -411.62, -8.8)",
    filter: "url(#Ellipse_173)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_173-11",
    "data-name": "Ellipse 173",
    cx: 65.723,
    cy: 65.723,
    r: 65.723,
    transform: "translate(411.53 8.5)",
    fill: "#22b7bb",
    stroke: "#fff",
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2343",
    "data-name": "Path 2343",
    d: "M522.159,879.582a4.458,4.458,0,0,1-2.643.706c-1.944-.027-3.889,0-5.833-.014a.375.375,0,0,0-.411.284q-4.644,11.539-9.3,23.073a4.286,4.286,0,0,1-2.332,2.543,3.6,3.6,0,0,1-5.119-2.906,4.349,4.349,0,0,1,.289-2.294q2.5-6.041,5-12.081c.538-1.306,1.023-2.634,1.6-3.924.646-1.455,1.224-2.937,1.848-4.4.032-.076.059-.154.09-.233-.107-.081-.214-.045-.314-.045-1.088,0-2.176,0-3.265,0a3.744,3.744,0,0,1-.9-7.391,3.95,3.95,0,0,1,.973-.1c2.135,0,4.269,0,6.4.007a.376.376,0,0,0,.416-.279c.505-1.263,1.027-2.521,1.542-3.78q.956-2.293,1.911-4.588,2.626-6.35,5.244-12.7a9.256,9.256,0,0,1,1.555-2.667,4.821,4.821,0,0,1,3.658-1.748,19.76,19.76,0,0,1,2.915.043,5.058,5.058,0,0,1,3.48,2.213,14.093,14.093,0,0,1,1.5,3.028q5.079,12.274,10.154,24.549,4.035,9.759,8.068,19.518c.669,1.62,1.359,3.231,2,4.859a4.092,4.092,0,0,1-1.138,4.472,3.91,3.91,0,0,1-5.513-.956,11.981,11.981,0,0,1-1.143-2.464q-6.778-16.845-13.55-33.693-2.734-6.8-5.471-13.6c-.039-.1-.081-.192-.148-.349-.318.787-.615,1.52-.91,2.254q-3.1,7.714-6.19,15.427a1.348,1.348,0,0,1-.058.147c-.1.194-.045.252.169.25,1.025-.007,2.05,0,3.075,0a3.78,3.78,0,0,1,2.39,6.8A.33.33,0,0,0,522.159,879.582Z",
    transform: "translate(-458.068 -811.313)",
    fill: "#fefefe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "NEM",
    transform: "translate(-15415.466 109.329)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -159.14, -116.65)",
    filter: "url(#Ellipse_170)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_170-2",
    "data-name": "Ellipse 170",
    cx: 78.079,
    cy: 78.079,
    r: 78.079,
    transform: "translate(159.14 116.65)",
    fill: "#22b7bb",
    stroke: "#fff",
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1443",
    "data-name": "Group 1443",
    transform: "translate(42.247 96.93) rotate(-60)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1584",
    "data-name": "Path 1584",
    d: "M48.584,0c.319-.018.086.167.063.218-.3.618-.606,1.232-.913,1.847Q37.244,23.06,26.757,44.054a1.043,1.043,0,0,1-.248.421.835.835,0,0,1-.14-.43c-.146-1.029-.284-2.062-.424-3.094q-.34-2.466-.68-4.938c-.322-2.312-.653-4.625-.976-6.934-.23-1.647-.451-3.294-.68-4.941-.325-2.336-.659-4.672-.982-7.011-.072-.531-.06-.534-.516-.245Q11.057,23.9,0,30.905c.021-.152.158-.191.262-.257q11.1-7.04,22.2-14.076a.858.858,0,0,0,.447-.2Q35.6,8.328,48.292.276C48.405.2,48.564.171,48.584,0Z",
    transform: "translate(22.071 0.042)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1585",
    "data-name": "Path 1585",
    d: "M49.557.044c-.021.17-.179.2-.292.274Q36.577,8.369,23.88,16.418a.857.857,0,0,1-.447.2c-.331-.23-.659-.468-1-.689-1.4-.916-2.807-1.826-4.21-2.742Q15.3,11.268,12.37,9.347c-1.39-.91-2.787-1.811-4.177-2.721Q4.9,4.468,1.611,2.3A9.24,9.24,0,0,1,0,1.174a22.658,22.658,0,0,1,2.545-.1q18-.421,36-.829L49.3.008C49.39,0,49.479-.022,49.557.044Z",
    transform: "translate(21.099 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1586",
    "data-name": "Path 1586",
    d: "M.125,14.215Q11.179,7.2,22.237.192c.456-.289.444-.286.516.245.322,2.339.656,4.675.981,7.011.23,1.647.451,3.294.68,4.941.322,2.309.653,4.622.976,6.934q.345,2.47.68,4.938c.14,1.032.277,2.065.424,3.094a.834.834,0,0,0,.14.43c-.125.233-.239.012-.325-.033-1.474-.737-2.942-1.489-4.41-2.238q-3.679-1.88-7.354-3.753L4.072,16.42Q2.189,15.462.313,14.5c-.11-.057-.248-.078-.313-.2Z",
    transform: "translate(21.946 16.732)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1587",
    "data-name": "Path 1587",
    d: "M1.1,29.773l-.125.078a10.077,10.077,0,0,1-.1-1.775Q.429,14.215,0,.352c0-.09,0-.176,0-.266L.127,0h0A9.248,9.248,0,0,0,1.738,1.128Q5.018,3.3,8.319,5.451c1.39.91,2.787,1.811,4.177,2.721q2.931,1.915,5.857,3.837c1.4.916,2.807,1.826,4.21,2.742.337.221.665.459,1,.689q-11.1,7.035-22.2,14.077C1.257,29.582,1.12,29.621,1.1,29.773Z",
    transform: "translate(20.972 1.174)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1588",
    "data-name": "Path 1588",
    d: "M.121,40.988c-.239-.072-.057-.2-.024-.281q.8-1.983,1.611-3.959L13.47,8.008Q15.045,4.159,16.623.313c.042-.1.089-.209.134-.313.134.066.09.182.093.275q.264,8.217.519,16.431.206,6.422.406,12.847a1.192,1.192,0,0,0,.024.149c-.045.027-.09.051-.131.078Q9.012,35.27.357,40.759C.264,40.818.142,40.851.121,40.988Z",
    transform: "translate(0 3.961)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1589",
    "data-name": "Path 1589",
    d: "M0,11.287c.021-.137.143-.17.236-.23Q8.891,5.566,17.546.078c.042-.027.086-.051.131-.078q7.944,4.064,15.891,8.124,5.093,2.6,10.189,5.2c.1.057.233.087.307.2-.113.113-.245.054-.364.048Q21.986,12.446.266,11.308C.176,11.3.089,11.293,0,11.287Z",
    transform: "translate(0.121 33.663)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2012",
    "data-name": "Group 2012",
    transform: "translate(-15528.346 332)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -46.26, -339.32)",
    filter: "url(#Ellipse_231)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_231-6",
    "data-name": "Ellipse 231",
    cx: 30.712,
    cy: 30.712,
    rx: 30.712,
    ry: 30.712,
    transform: "translate(46.26 339.32)",
    fill: "#22b7bb",
    stroke: "#fff",
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2051",
    "data-name": "Group 2051",
    transform: "translate(-305.84 -410.475)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2348",
    "data-name": "Path 2348",
    d: "M335.719,474.975c-1.668-1.052-3.33-2.114-5.007-3.153-2.777-1.72-5.57-3.415-8.336-5.152a1.262,1.262,0,0,1-.574-.85c-.035-4.942-.025-9.884-.022-14.825a3.372,3.372,0,0,1,.066-.419,21.135,21.135,0,0,1,1.934,1.142,1.17,1.17,0,0,1,.3.843q.028,5.889,0,11.778a1.186,1.186,0,0,0,.628,1.193c2.777,1.668,5.527,3.379,8.287,5.073.156.1.318.179.562.316.022-.335.052-.569.052-.8,0-3.157-.012-6.315.016-9.472a1,1,0,0,0-.641-1.092,6.711,6.711,0,0,1-.717-.4c-1.91-1.1-1.91-1.1-1.713-3.533.365.2.685.373,1,.553,1.214.7,2.412,1.424,3.645,2.085a1.125,1.125,0,0,1,.674,1.155c-.016,5.188,0,10.377.009,15.565Z",
    transform: "translate(0 -17.384)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2349",
    "data-name": "Path 2349",
    d: "M368.958,474.953a.911.911,0,0,0,.018-.245c-.363-1.788.447-2.778,2.007-3.645,3.117-1.731,6.108-3.69,9.132-5.584a1.287,1.287,0,0,0,.606-.836c.04-3.294.023-6.589.018-9.884a1.224,1.224,0,0,0-.093-.285c-2.163,1.245-4.3,2.471-6.427,3.7-.951.549-2.239.9-2.746,1.721-.5.808-.184,2.107-.256,3.189a.9.9,0,0,1-.261.622c-.584.393-1.212.72-1.975,1.16,0-1.7.071-3.255-.025-4.8a2.012,2.012,0,0,1,1.228-2.17c4.1-2.279,8.145-4.667,12.21-7.014.165-.1.335-.184.628-.344.018.335.042.587.042.839,0,4.723-.01,9.445.017,14.168a1.189,1.189,0,0,1-.668,1.167q-6.328,3.859-12.631,7.759c-.23.142-.439.318-.659.478Z",
    transform: "translate(-31.754 -17.362)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2350",
    "data-name": "Path 2350",
    d: "M329.4,432.126c.24.164.407.294.589.4,2.686,1.553,5.381,3.092,8.056,4.664a.855.855,0,0,0,1.1-.009,5.259,5.259,0,0,1,.639-.376c1.971-1.135,1.971-1.135,4.042.234-.932.54-1.809,1.061-2.7,1.561-.857.482-1.723,1.305-2.59,1.311-.832.006-1.672-.842-2.5-1.321-3.709-2.139-7.417-4.28-11.215-6.472.268-.167.459-.3.663-.411q6.3-3.408,12.618-6.8a1.084,1.084,0,0,1,.871-.06c4.361,2.326,8.706,4.681,13.053,7.033a3.334,3.334,0,0,1,.323.238c-.688.4-1.3.8-1.967,1.107a1.092,1.092,0,0,1-.8-.15q-5.156-2.76-10.29-5.561a1.225,1.225,0,0,0-1.353-.027C335.132,429.046,332.3,430.558,329.4,432.126Z",
    transform: "translate(-2.054 0)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2013",
    "data-name": "Group 2013",
    transform: "translate(-14997.307 96.13)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -577.3, -103.45)",
    filter: "url(#Ellipse_172-2)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_172-10",
    "data-name": "Ellipse 172",
    cx: 46.848,
    cy: 46.848,
    rx: 46.848,
    ry: 46.848,
    transform: "translate(577.3 103.45)",
    fill: "#2f8bf7",
    stroke: "#fff",
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2047",
    "data-name": "Group 2047",
    transform: "translate(-1406.386 -15.732)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2323",
    "data-name": "Path 2323",
    d: "M1482.57,63.809a1.942,1.942,0,0,0-.048.515,29.516,29.516,0,0,1-.5,3.9,28.571,28.571,0,0,1-2.451,7.267A29.118,29.118,0,0,1,1466.379,88.8a28.665,28.665,0,0,1-7.546,2.574,29.342,29.342,0,0,1-34.467-23.6,28.794,28.794,0,0,1-.455-6.024,29.353,29.353,0,0,1,22.146-27.62,28.471,28.471,0,0,1,4.307-.75c.516-.05,1.032-.089,1.55-.112.031,0,.07.016.091-.026h2.464c.021.042.059.024.09.026a29.206,29.206,0,0,1,12.144,3.248,29.1,29.1,0,0,1,12.47,12.356,28.734,28.734,0,0,1,2.847,8.035,29.39,29.39,0,0,1,.5,3.949,1.876,1.876,0,0,0,.046.516Zm-29.314-28.273a27.022,27.022,0,1,0,27.022,27.039A27,27,0,0,0,1453.256,35.536Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2324",
    "data-name": "Path 2324",
    d: "M1504.81,95.486a7.177,7.177,0,0,1,1.9.732,4.126,4.126,0,0,1,2.067,2.916,7.653,7.653,0,0,1-.4,4.288,5.033,5.033,0,0,1-2.467,2.659,9.957,9.957,0,0,1-2.861.917,19.987,19.987,0,0,1-2.6.295c-.133.006-.13.075-.13.17,0,1.452,0,2.9,0,4.356,0,.127-.023.174-.165.173-.846-.008-1.691-.006-2.537,0-.115,0-.147-.029-.146-.146,0-1.442,0-2.885.006-4.327,0-.146-.041-.175-.179-.173-.645.008-1.291.007-1.936,0-.121,0-.155.029-.154.153,0,1.452,0,2.9.006,4.356,0,.127-.027.164-.16.163q-1.254-.01-2.508,0c-.138,0-.179-.028-.179-.174.006-1.467,0-2.933.007-4.4,0-.144-.041-.175-.179-.174-1.78,0-3.559,0-5.339.006-.136,0-.182-.014-.155-.171.172-1.03.334-2.061.493-3.093.016-.1.052-.123.147-.123q1,.006,2.009,0a.992.992,0,0,0,1-1q0-6.314,0-12.628a1.424,1.424,0,0,0-1.207-1.3,12.588,12.588,0,0,0-1.479-.029q-.447,0-.894.015c-.078,0-.089-.028-.089-.092q0-1.423,0-2.845c0-.093.043-.1.116-.1.352,0,.7,0,1.056,0,1.476,0,2.953,0,4.429,0,.123,0,.153-.032.153-.154,0-1.447,0-2.894-.005-4.341,0-.126.021-.175.164-.174.831.008,1.662.007,2.493,0,.125,0,.164.026.164.159-.005,1.408,0,2.816-.007,4.224,0,.138.04.167.17.166q.968-.01,1.936,0c.126,0,.164-.026.163-.159-.005-1.4,0-2.806-.007-4.209,0-.155.045-.182.188-.181q1.247.01,2.493,0c.14,0,.166.043.166.172,0,1.413,0,2.826,0,4.239,0,.227,0,.227.22.248a14.8,14.8,0,0,1,2.5.444,7.071,7.071,0,0,1,2.382,1.094,4.24,4.24,0,0,1,1.672,2.6,5.917,5.917,0,0,1,.005,2.572,4.067,4.067,0,0,1-2.081,2.735Zm-9.5,5.3q0,1.5,0,2.992c0,.089,0,.141.12.141a34.122,34.122,0,0,0,3.457-.085,9.611,9.611,0,0,0,2.287-.475,3.69,3.69,0,0,0,1.429-.866,2.567,2.567,0,0,0-.355-3.774,4.218,4.218,0,0,0-1.213-.608,11.054,11.054,0,0,0-3.132-.464c-.826-.028-1.652,0-2.478.016-.123,0-.115.063-.115.146Q1495.309,99.3,1495.308,100.787Zm0-8.822q0,1.356,0,2.712c0,.081-.011.149.114.149a22.483,22.483,0,0,0,3.248-.117,5.938,5.938,0,0,0,1.955-.578,2.369,2.369,0,0,0,1.23-2.858,2.318,2.318,0,0,0-1.372-1.563,7.162,7.162,0,0,0-2.687-.576c-.786-.05-1.573-.007-2.359,0-.105,0-.129.034-.129.134C1495.312,90.167,1495.311,91.066,1495.311,91.965Z",
    transform: "translate(-43.831 -33.509)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2325",
    "data-name": "Path 2325",
    d: "M1437.8,91.221a25.089,25.089,0,0,1,5.035-15.068c.478-.644.994-1.256,1.531-1.853.069-.076.1-.08.176-.005q.7.715,1.421,1.42c.089.087.081.13,0,.218a22.811,22.811,0,0,0-5.718,12.628,22.205,22.205,0,0,0-.089,4.346,22.744,22.744,0,0,0,4.216,11.589,20.452,20.452,0,0,0,1.593,1.971c.081.088.081.135,0,.22q-.716.725-1.418,1.464c-.078.081-.111.077-.185,0a25.077,25.077,0,0,1-5.525-9.8,24.633,24.633,0,0,1-.89-4.473Q1437.8,92.55,1437.8,91.221Z",
    transform: "translate(-9.703 -28.62)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2326",
    "data-name": "Path 2326",
    d: "M1585.368,90.828a25.07,25.07,0,0,1-5.042,15.3c-.475.64-.989,1.249-1.522,1.841-.064.071-.1.078-.169.006q-.716-.725-1.442-1.441c-.076-.075-.064-.113,0-.184a22.8,22.8,0,0,0,.069-30.509c-.153-.171-.154-.17.006-.33.46-.46.922-.917,1.377-1.381.082-.083.114-.069.184.009a25.07,25.07,0,0,1,5.375,9.349,24.525,24.525,0,0,1,.951,4.311A25.564,25.564,0,0,1,1585.368,90.828Z",
    transform: "translate(-106.98 -28.505)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2327",
    "data-name": "Path 2327",
    d: "M1481.834,47.13a25.166,25.166,0,0,1,16.9,6.557c.082.074.083.11,0,.188q-.716.7-1.42,1.421c-.085.087-.129.069-.207,0a22.792,22.792,0,0,0-11.727-5.6,22.252,22.252,0,0,0-5.334-.206,22.717,22.717,0,0,0-12.37,4.853q-.589.461-1.14.968c-.072.067-.113.071-.187,0q-.723-.718-1.457-1.425c-.079-.076-.09-.114,0-.2a25.152,25.152,0,0,1,13.421-6.309A24.8,24.8,0,0,1,1481.834,47.13Z",
    transform: "translate(-28.574 -9.693)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2328",
    "data-name": "Path 2328",
    d: "M1481.273,194.627a24.662,24.662,0,0,1-13.481-4.321,25.44,25.44,0,0,1-2.833-2.225c-.092-.083-.093-.124,0-.211q.712-.7,1.41-1.41c.076-.077.116-.079.2-.006a22.79,22.79,0,0,0,30.567.008c.078-.071.123-.088.208,0q.716.715,1.446,1.415c.081.078.089.118,0,.2a25.165,25.165,0,0,1-12.739,6.2A27.412,27.412,0,0,1,1481.273,194.627Z",
    transform: "translate(-28.616 -106.92)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2014",
    "data-name": "Group 2014",
    transform: "translate(-15044.154 25.759)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -530.45, -33.08)",
    filter: "url(#Ellipse_172-3)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_172-11",
    "data-name": "Ellipse 172",
    cx: 46.848,
    cy: 46.848,
    rx: 46.848,
    ry: 46.848,
    transform: "translate(530.45 33.08)",
    fill: "#2f8bf7",
    stroke: "#fff",
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2046",
    "data-name": "Group 2046",
    transform: "translate(-1166.599 -72.188)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2318",
    "data-name": "Path 2318",
    d: "M1239.77,119.128c0,4.743-.016,9.485.018,14.228a1.4,1.4,0,0,1-.822,1.41q-12.441,7.146-24.85,14.347a1.344,1.344,0,0,1-1.553-.023q-12.354-7.208-24.738-14.363a1.271,1.271,0,0,1-.717-1.279q.027-14.408,0-28.816a1.267,1.267,0,0,1,.724-1.273q12.375-7.171,24.717-14.4a1.261,1.261,0,0,1,1.466,0q12.535,7.254,25.1,14.456a1.2,1.2,0,0,1,.669,1.218C1239.761,109.462,1239.77,114.3,1239.77,119.128Zm-2.893-.09c0-4.292-.009-8.584.012-12.876a1.1,1.1,0,0,0-.653-1.134c-.981-.516-1.926-1.1-2.887-1.654q-9.546-5.5-19.1-11c-.472-.272-.881-.611-1.546-.22-7.369,4.326-14.763,8.608-22.132,12.934a1.428,1.428,0,0,0-.607,1.032c-.033,8.584-.021,17.168-.037,25.752a1.142,1.142,0,0,0,.667,1.13q10.973,6.358,21.921,12.76a1.267,1.267,0,0,0,1.471.044q11.131-6.444,22.3-12.825a1.12,1.12,0,0,0,.6-1.16C1236.871,127.563,1236.877,123.3,1236.877,119.038Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2319",
    "data-name": "Path 2319",
    d: "M1214.352,112.941h.928c6.3,0,12.6.011,18.894-.015.7,0,.965.189,1.121.9.707,3.211,1.491,6.406,2.271,9.706h-25.576C1212.776,120,1213.556,116.51,1214.352,112.941Z",
    transform: "translate(-11.489 -11.176)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2320",
    "data-name": "Path 2320",
    d: "M1198.988,144.634c2.254-1.683,4.432-3.324,6.636-4.928a.88.88,0,0,1,.778.049c1.758,1.091,3.506,2.2,5.222,3.354a1.319,1.319,0,0,1,.473.936q.067,2.745.009,5.492a1.771,1.771,0,0,0,.611,1.489c1.2,1.091,2.352,2.229,3.514,3.359a2.32,2.32,0,0,1-.045,3.12c-1.141,1.065-2.26,2.154-3.441,3.173a2.86,2.86,0,0,1-1.257.5c-2.281.48-3.549-.488-4.623-2.579-2.272-4.422-4.885-8.669-7.356-12.989C1199.345,145.323,1199.2,145.03,1198.988,144.634Z",
    transform: "translate(-5.486 -23.509)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2321",
    "data-name": "Path 2321",
    d: "M1257.223,144.621c-.351.621-.658,1.168-.969,1.711q-4.014,7.029-8.017,14.064a1.428,1.428,0,0,1-1.25.777,5.11,5.11,0,0,1-5.039-1.971,11.035,11.035,0,0,0-1.568-1.483,2.082,2.082,0,0,1-.832-1.672,2.507,2.507,0,0,1,.95-2.172c1.089-.941,2.125-1.948,3.119-2.988a2.02,2.02,0,0,0,.513-1.228c.055-1.859-.007-3.722.051-5.581a1.541,1.541,0,0,1,.575-1.065c1.624-1.13,3.289-2.2,4.961-3.261a.992.992,0,0,1,.853-.107C1252.794,141.269,1254.987,142.937,1257.223,144.621Z",
    transform: "translate(-24.213 -23.485)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2322",
    "data-name": "Path 2322",
    d: "M1236.69,135.728c-.642,1.73-1.288,3.368-1.846,5.036a4.831,4.831,0,0,0-.218,1.821c.124,1.824.329,3.641.51,5.546h-10.318c.177-1.75.4-3.47.5-5.2a6.9,6.9,0,0,0-.28-2.436c-.507-1.588-1.161-3.128-1.785-4.77Z",
    transform: "translate(-16.691 -21.704)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2017",
    "data-name": "Group 2017",
    transform: "translate(-15254.298 17.192)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -320.31, -24.52)",
    filter: "url(#Ellipse_173-2)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_173-12",
    "data-name": "Ellipse 173",
    cx: 50.004,
    cy: 50.004,
    r: 50.004,
    transform: "translate(320.22 24.22)",
    fill: "#22b7bb",
    stroke: "#fff",
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2050",
    "data-name": "Group 2050",
    transform: "translate(-158.516 -359.996)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2344",
    "data-name": "Path 2344",
    d: "M186.819,400.432A18.479,18.479,0,1,1,205.312,418.9,18.484,18.484,0,0,1,186.819,400.432ZM205.3,388.111a12.316,12.316,0,1,0,12.317,12.311A12.267,12.267,0,0,0,205.3,388.111Z",
    transform: "translate(0 -0.001)",
    fill: "#fefefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2345",
    "data-name": "Path 2345",
    d: "M233.3,486.893a3.192,3.192,0,0,1-3.022-1.988,2.9,2.9,0,0,1,.658-3.232c4.11-4.109,8.241-8.2,12.319-12.339a3.056,3.056,0,0,1,5.12,1.13,2.739,2.739,0,0,1-.674,3.1q-6.148,6.164-12.309,12.316A3.128,3.128,0,0,1,233.3,486.893Z",
    transform: "translate(-24.726 -49.436)",
    fill: "#fefefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2346",
    "data-name": "Path 2346",
    d: "M273.4,385.025a3.031,3.031,0,0,1,3.074-3.075,3.1,3.1,0,0,1,3.086,3.089,3.08,3.08,0,0,1-6.159-.014Z",
    transform: "translate(-49.522)",
    fill: "#fefefe"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2018",
    "data-name": "Group 2018",
    transform: "translate(-15400.894 223.353)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -173.71, -230.68)",
    filter: "url(#Ellipse_173-3)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_173-13",
    "data-name": "Ellipse 173",
    cx: 41.176,
    cy: 41.176,
    r: 41.176,
    transform: "translate(173.62 230.38)",
    fill: "#22b7bb",
    stroke: "#fff",
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1583",
    "data-name": "Path 1583",
    d: "M86.336,58.519h0c-.21.016-1.294.08-3.713.08-1.924,0-3.29-.058-3.769-.08h0c-7.435-.327-12.985-1.621-12.985-3.171s5.55-2.842,12.985-3.174V57.23c.486.035,1.878.117,3.8.117,2.309,0,3.465-.1,3.673-.115V52.177c7.419.331,12.957,1.625,12.957,3.171s-5.536,2.84-12.957,3.169h0Zm0-6.865V47.13H96.691v-6.9H68.5v6.9H78.852v4.523c-8.414.387-14.742,2.053-14.742,4.051s6.328,3.662,14.742,4.051v14.5h7.482v-14.5c8.4-.387,14.713-2.052,14.713-4.047s-6.312-3.661-14.713-4.049h0Zm0,0Z",
    transform: "translate(-41.118 -15.576)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2019",
    "data-name": "Group 2019",
    transform: "translate(-15279.449 387.58)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -295.15, -394.9)",
    filter: "url(#Ellipse_173-4)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_173-14",
    "data-name": "Ellipse 173",
    cx: 58.231,
    cy: 58.231,
    r: 58.231,
    transform: "translate(295.06 394.61)",
    fill: "#22b7bb",
    stroke: "#fff",
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2055",
    "data-name": "Group 2055",
    transform: "translate(293.996 -1.655)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2361",
    "data-name": "Path 2361",
    d: "M-224.954,88.039a28.361,28.361,0,0,1-3.924-.454c-.69-.153-1.39-.265-2.076-.431-.532-.128-1.05-.31-1.574-.47q-.545-.166-1.088-.339c-.412-.132-.827-.255-1.232-.405-.386-.144-.759-.322-1.14-.478-.278-.113-.561-.21-.839-.324-.54-.22-1.09-.421-1.613-.676-.887-.433-1.756-.9-2.633-1.357-.281-.145-.573-.27-.85-.422-.423-.233-.838-.479-1.254-.724-.44-.258-.882-.514-1.315-.784-.523-.327-1.036-.668-1.553-1-.414-.269-.834-.53-1.239-.812-.477-.333-.943-.683-1.41-1.031-.539-.4-1.08-.8-1.609-1.214-.564-.44-1.118-.892-1.67-1.347s-1.1-.9-1.62-1.37q-.848-.765-1.652-1.578c-.957-.97-1.912-1.945-2.839-2.944-.468-.5-.875-1.064-1.306-1.6-.363-.454-.727-.907-1.078-1.37-.251-.331-.487-.673-.717-1.019-.366-.55-.74-1.1-1.077-1.664s-.654-1.187-.975-1.784c-.179-.333-.357-.668-.522-1.008a7.926,7.926,0,0,1-.323-.753c-.147-.405-.286-.814-.411-1.226-.134-.44-.253-.884-.369-1.329a4.374,4.374,0,0,1-.167-.777c-.058-.813-.126-1.628-.121-2.442a5.857,5.857,0,0,1,.434-2.255,10.282,10.282,0,0,1,.774-1.41c.326-.524.682-1.03,1.038-1.535.406-.576.831-1.139,1.242-1.713.386-.538.758-1.086,1.146-1.622.341-.471.7-.927,1.041-1.4.35-.488.677-.993,1.026-1.481s.7-.948,1.053-1.424c.219-.3.43-.6.645-.905.354-.5.71-.99,1.061-1.487.575-.813,1.142-1.632,1.721-2.442q.662-.926,1.345-1.836a18.874,18.874,0,0,1,1.335-1.7,7.033,7.033,0,0,1,1.408-1.111,14.816,14.816,0,0,1,1.664-.8,3.068,3.068,0,0,1,.436-.111c.2-.057.4-.121.606-.185a1.117,1.117,0,0,1,.2-.074,20.618,20.618,0,0,1,4.349-.2c.6.064,1.2.1,1.8.2.7.123,1.4.307,2.1.465.112.025.224.055.335.085.674.178,1.348.354,2.021.536.452.123.9.246,1.35.386.328.1.649.23.969.355.689.271,1.38.535,2.06.827.614.263,1.215.558,1.821.84.48.224.964.439,1.436.679.494.251.973.531,1.462.79.28.148.575.268.851.423.376.211.74.445,1.11.667.443.267.89.53,1.331.8.347.213.692.429,1.029.656.549.368,1.1.739,1.634,1.121.5.352.981.72,1.471,1.082.469.346.945.682,1.4,1.041.492.386.971.79,1.448,1.195.652.555,1.323,1.092,1.94,1.686,1.1,1.056,2.164,2.145,3.236,3.228.441.446.874.9,1.289,1.372.35.4.672.82,1,1.235.376.475.76.946,1.118,1.435s.685.985,1.014,1.487c.348.531.7,1.061,1.015,1.609.273.472.5.97.75,1.456.112.22.233.436.332.661.263.6.537,1.189.764,1.8.169.452.255.934.407,1.394a9.937,9.937,0,0,1,.359,2.28,8.679,8.679,0,0,1-.18,2.725,4.967,4.967,0,0,1-.746,1.771c-.7.987-1.375,1.987-2.064,2.978-.533.767-1.068,1.533-1.611,2.293-.446.625-.91,1.236-1.357,1.861-.55.768-1.087,1.545-1.635,2.314-.409.573-.831,1.137-1.24,1.709-.589.825-1.168,1.658-1.759,2.482-.4.558-.817,1.1-1.221,1.66-.462.635-.913,1.277-1.377,1.911a6.723,6.723,0,0,1-2.139,1.942,10.54,10.54,0,0,1-2.348.938A17.544,17.544,0,0,1-224.954,88.039Zm-19.013-54.882a12.419,12.419,0,0,0-3.265.367.425.425,0,0,0-.1.032c-.4.18-.815.335-1.2.549a6.423,6.423,0,0,0-1.057.73,3.786,3.786,0,0,0-.934,1.172,5.656,5.656,0,0,0-.534,1.42,6.131,6.131,0,0,0-.042,2.379,6.64,6.64,0,0,0,.331,1.526,12.985,12.985,0,0,1,.391,1.314,6.316,6.316,0,0,0,.341.86c.345.7.706,1.4,1.067,2.091.1.195.23.374.342.564.23.387.438.788.688,1.161.368.55.759,1.083,1.149,1.618.305.42.612.839.937,1.244.349.434.715.854,1.081,1.273.419.479.836.961,1.274,1.422.536.565,1.088,1.116,1.642,1.664.453.448.912.89,1.384,1.318.509.463,1.033.91,1.555,1.358.49.42.973.851,1.483,1.245.72.555,1.46,1.085,2.2,1.618.534.386,1.074.764,1.616,1.139q.512.355,1.036.691c.43.276.865.544,1.3.813.389.24.777.482,1.17.714.418.246.837.49,1.264.721.472.255.954.491,1.429.738s.926.506,1.4.731c.557.264,1.126.5,1.694.741.609.258,1.219.515,1.835.756.443.174.894.326,1.344.48s.885.309,1.336.436c.518.145,1.046.25,1.566.39a15.5,15.5,0,0,0,2.837.56c.563.043,1.12.19,1.682.215a12.684,12.684,0,0,0,2.94-.161,9.362,9.362,0,0,0,1.769-.452,8.447,8.447,0,0,0,1.325-.759,4.191,4.191,0,0,0,1.631-2.1,5.68,5.68,0,0,0,.33-2.854,12.926,12.926,0,0,0-.755-2.971c-.143-.361-.253-.736-.4-1.1-.108-.266-.247-.522-.381-.777-.15-.287-.308-.57-.466-.853-.343-.615-.675-1.237-1.039-1.84-.231-.382-.513-.734-.772-1.1-.362-.51-.709-1.031-1.091-1.525-.4-.516-.83-1.009-1.252-1.506-.446-.525-.881-1.061-1.354-1.561-.653-.69-1.332-1.356-2.01-2.023-.465-.457-.935-.909-1.422-1.343s-1.007-.861-1.52-1.281q-1.086-.89-2.185-1.765c-.262-.209-.543-.4-.812-.6-.366-.273-.725-.557-1.1-.822-.345-.246-.7-.473-1.054-.711-.386-.262-.762-.538-1.155-.787-.536-.339-1.086-.657-1.629-.985-.444-.269-.882-.55-1.334-.8-.414-.234-.846-.437-1.268-.657-.538-.281-1.073-.569-1.614-.845-.234-.119-.483-.212-.722-.323-.757-.352-1.507-.719-2.27-1.056-.507-.224-1.028-.421-1.552-.607q-.929-.332-1.873-.625c-.464-.144-.935-.263-1.406-.385-.658-.171-1.312-.364-1.978-.494s-1.346-.214-2.024-.282C-242.76,33.2-243.365,33.189-243.967,33.157Zm4.75,26.977a1.948,1.948,0,0,0-.258-.44c-.354-.332-.735-.635-1.094-.962-.608-.553-1.218-1.106-1.808-1.679-.977-.949-1.949-1.9-2.9-2.875-.487-.5-.932-1.037-1.386-1.567-.483-.563-.964-1.128-1.426-1.709-.329-.414-.625-.855-.932-1.287-.26-.365-.536-.722-.764-1.107-.358-.605-.689-1.226-1.016-1.849-.266-.507-.515-1.023-.759-1.541a6.047,6.047,0,0,1-.323-.808c-.141-.463-.251-.935-.379-1.4-.049-.18-.365-.427-.506-.406a.473.473,0,0,0-.371.512.69.69,0,0,0,.013.212c.226.733.45,1.467.689,2.2a5.922,5.922,0,0,0,.325.779c.147.3.324.579.481.871.236.442.45.9.7,1.33s.532.851.818,1.263c.452.653.9,1.309,1.385,1.939.43.56.9,1.086,1.362,1.624.315.37.628.741.958,1.1.346.375.712.732,1.068,1.1s.7.743,1.067,1.1c.422.412.865.8,1.292,1.21.358.341.691.709,1.061,1.035.643.567,1.312,1.1,1.955,1.67.13.114.253.158.374.076A2.633,2.633,0,0,0-239.217,60.133Zm25.84,11.678c.7-.055,1.435-.107,2.167-.171a.435.435,0,0,0,.454-.531c-.02-.281-.132-.365-.5-.367-.08,0-.159.008-.239.011-.789.022-1.579.074-2.367.058a9.65,9.65,0,0,1-2.8-.261.594.594,0,0,0-.39-.03,1.22,1.22,0,0,0-.507.4c-.1.177.068.372.352.464a3.331,3.331,0,0,0,.716.2C-215.463,71.672-214.437,71.736-213.377,71.811Zm-5.554-.707c.345-.029.5-.151.514-.438a.519.519,0,0,0-.457-.5c-.14-.024-.279-.052-.417-.087-.351-.09-.7-.2-1.052-.274-.4-.087-.708.206-.582.546a.628.628,0,0,0,.5.4c.268.057.529.142.8.206C-219.4,71.012-219.164,71.056-218.931,71.1Zm-33.627-30.179a3.834,3.834,0,0,0-.131-.587c-.116-.3-.312-.411-.543-.357a.6.6,0,0,0-.364.615,5.772,5.772,0,0,0,.15.754.4.4,0,0,0,.666.2C-252.548,41.387-252.577,41.16-252.558,40.925Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2362",
    "data-name": "Path 2362",
    d: "M-183.827,65.629a10.893,10.893,0,0,1,3.168.487c.488.122.974.258,1.45.42.356.121.7.291,1.039.446q.409.183.811.382c.664.327,1.345.627,1.984,1,.724.418,1.417.89,2.11,1.359.642.435,1.289.867,1.89,1.355a22.73,22.73,0,0,1,2.029,1.819q1.307,1.352,2.5,2.812a9.954,9.954,0,0,1,1.205,1.856,13.524,13.524,0,0,1,.913,2.364,3.009,3.009,0,0,1,.018,1.473,2.091,2.091,0,0,1-1.664,1.568,6.329,6.329,0,0,1-1.79.192,11.77,11.77,0,0,1-2.479-.41c-.482-.147-.974-.26-1.451-.42-.423-.142-.834-.323-1.247-.494-.3-.124-.6-.249-.892-.392-.521-.255-1.039-.516-1.551-.789-.419-.224-.83-.461-1.236-.707s-.78-.484-1.158-.744c-.487-.335-.969-.677-1.439-1.035-.455-.346-.905-.7-1.337-1.078-.585-.51-1.166-1.028-1.72-1.571a16.887,16.887,0,0,1-1.311-1.419c-.5-.615-.972-1.255-1.415-1.913a14.309,14.309,0,0,1-.81-1.45,6.018,6.018,0,0,1-.451-1.04A7.182,7.182,0,0,1-187,68.143a2.085,2.085,0,0,1,1.206-2.135A3.369,3.369,0,0,1-183.827,65.629Z",
    transform: "translate(-52.634 -23.205)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2038",
    "data-name": "Group 2038",
    transform: "translate(-15459.125 297.834)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -115.48, -305.16)",
    filter: "url(#Ellipse_173-5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_173-15",
    "data-name": "Ellipse 173",
    cx: 58.231,
    cy: 58.231,
    r: 58.231,
    transform: "translate(115.39 304.86)",
    fill: "#22b7bb",
    stroke: "#fff",
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2056",
    "data-name": "Group 2056",
    transform: "translate(-375.384 40.523)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2363",
    "data-name": "Path 2363",
    d: "M404.574,77.988c1.472-.448,2.567-1.653,4.075-2.03l-.01-.011c.1,3.056-1.023,4.419-4.064,4.948Z",
    transform: "translate(0 -61.879)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2364",
    "data-name": "Path 2364",
    d: "M448.763,55.306a22.632,22.632,0,1,1,22.658-22.5A22.483,22.483,0,0,1,448.763,55.306Zm7.1-22.1c4.092-2.288,3.383-6.7.349-8.271-.789-.409-2.064-.461-2.259-1.337a5.609,5.609,0,0,1,.548-2.8c.3-.853-.037-1.039-.757-1.257-1-.3-1.681-.289-1.809.978-.053.523-.319,1.024-.37,1.547-.087.886-.566.966-1.3.837-.942-.164-.841-.728-.653-1.394.183-.65.317-1.315.495-1.967.377-1.382-.952-1.173-1.537-1.512-.733-.426-.776.355-.879.864-.058.283-.161.557-.228.839-.572,2.4-.571,2.4-2.9,1.807-.421-.108-.851-.185-1.265-.316-.855-.269-1.486-.424-1.724.853-.194,1.04-.28,1.605,1,1.771,1.011.131,1.854.6,1.506,1.95-.863,3.369-1.685,6.749-2.508,10.127-.248,1.018-.8,1.3-1.814,1.007-.387-.111-.951-.6-1.306-.032a3.677,3.677,0,0,0-.881,2.248c.094.641,1,.543,1.575.689,3.062.778,3.063.773,2.357,3.778a1.169,1.169,0,0,1-.05.136c-.264.7-.007,1.04.713,1.244,1.009.285,1.781.384,1.854-1.021.027-.521.289-1.025.367-1.548.13-.869.539-1.088,1.392-.874.927.233.806.731.587,1.4s-.355,1.4-.53,2.108c-.068.275-.195.539.083.791a1.518,1.518,0,0,0,2.465-.664,8.52,8.52,0,0,0,.308-1.265c.129-1.3.714-1.73,2.018-1.322a6.507,6.507,0,0,0,2.021.086,5,5,0,0,0,5.076-3.762C458.659,36.438,458.215,35.079,455.867,33.2Z",
    transform: "translate(-15.266 -15.248)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2365",
    "data-name": "Path 2365",
    d: "M488.739,141.748c3.2-1.668,5.857-3.476,9.291-4.141a23.424,23.424,0,0,0,15.438-9.928c1.065-1.556,3.143-2.013,4.721-3.032a3.048,3.048,0,0,1,1.563-.684C516.209,136.245,501.077,144.178,488.739,141.748Z",
    transform: "translate(-59.55 -95.852)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2366",
    "data-name": "Path 2366",
    d: "M415.239,4.991c3.524-10.117,15.983-17.335,28-16.423.023.534-.478.538-.764.728A61.1,61.1,0,0,1,430.74-5.119a24.609,24.609,0,0,0-7.561,4.986A37.024,37.024,0,0,1,415.239,4.991Z",
    transform: "translate(-7.546)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2367",
    "data-name": "Path 2367",
    d: "M508.834-5.532c1.546-.9,3.062-1.829,4.616-2.685,1.379-.76,2.435.461,4.045.534C514.73-5.418,512.186-3.955,508.834-5.532Z",
    transform: "translate(-73.768 -2.154)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2368",
    "data-name": "Path 2368",
    d: "M412.151,50.3c-.111,3.268-2.353,4.561-4.736,5.749-.687.342-1.014.245-.9-.568.176-1.3.349-2.541,1.848-3.145C409.673,51.8,410.749,50.761,412.151,50.3Z",
    transform: "translate(-1.355 -43.73)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2369",
    "data-name": "Path 2369",
    d: "M583.525,104.326c.46-3.35.6-3.514,5.182-5.957.23,2.321-.165,3.135-2.159,4.3a12.373,12.373,0,0,1-3.036,1.644Z",
    transform: "translate(-126.606 -77.743)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2370",
    "data-name": "Path 2370",
    d: "M464.588,172.167c2.369-1.667,4.7-3.34,7.685-1.643C470.2,173.026,467.125,173.736,464.588,172.167Z",
    transform: "translate(-42.462 -128.295)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2371",
    "data-name": "Path 2371",
    d: "M534.312,3.05c1.216-.71,2.122-1.256,3.044-1.771a3.614,3.614,0,0,1,3.714.545c.3.311.2.51-.1.667a17.194,17.194,0,0,1-3.481,1.727C536.467,4.484,535.589,3.48,534.312,3.05Z",
    transform: "translate(-91.795 -8.84)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2372",
    "data-name": "Path 2372",
    d: "M448.319,164.005a4.351,4.351,0,0,1-2.515-1.156c-.443-.316-.105-.566.2-.762a12.527,12.527,0,0,1,2.933-1.549c1.167-.378,1.84.634,2.73,1.028.2.09.151.359-.034.471C450.443,162.755,449.247,163.455,448.319,164.005Z",
    transform: "translate(-29.021 -121.672)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2373",
    "data-name": "Path 2373",
    d: "M588.732,82.488c-.15-3.014.619-4.113,3.25-4.97.22-.072.424-.237.638.02.314.38.069,2.708-.367,2.966C591.145,81.159,590.011,81.771,588.732,82.488Z",
    transform: "translate(-130.286 -62.906)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2374",
    "data-name": "Path 2374",
    d: "M424.264,134.63c.033.442-2.207,2.118-2.885,2.1-1.075-.034-1.282-1.039-1.637-1.761-.209-.425,2.133-2.253,2.937-2.23C423.881,132.769,423.825,133.951,424.264,134.63Z",
    transform: "translate(-10.723 -102.058)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2375",
    "data-name": "Path 2375",
    d: "M557.141,15.321c-.689-.55-1.326-1.053-1.953-1.567a.351.351,0,0,1-.083-.258,10.962,10.962,0,0,1,3.437-2.019c.859.193,1.308.933,1.836,1.547a.394.394,0,0,1-.092.368C559.268,14.034,558.236,14.655,557.141,15.321Z",
    transform: "translate(-106.507 -16.262)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2376",
    "data-name": "Path 2376",
    d: "M589.326,58.288c.6.177.573.708.659,1.072.128.541.724,1.179-.06,1.68-.849.543-1.724,1.046-2.589,1.562-.41.245-.619.205-.822-.323-.593-1.538-.444-2.086.985-2.921Z",
    transform: "translate(-128.498 -49.384)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2377",
    "data-name": "Path 2377",
    d: "M406.45,99.734a.961.961,0,0,1,.634-1.121,12.251,12.251,0,0,1,1.123-.658c.614-.228,1.16-1.134,1.75-.728.62.427.176,1.454.5,2.172.137.308-.192.5-.447.654-.542.318-1.075.65-1.626.951C406.859,101.835,406.452,101.572,406.45,99.734Z",
    transform: "translate(-1.31 -76.862)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2378",
    "data-name": "Path 2378",
    d: "M436.088,150.031c-.911.547-1.795,1.12-2.718,1.619-.71.384-2.572-.673-2.576-1.422,0-.3.253-.381.458-.5.337-.189.684-.359,1.017-.555C434.4,147.925,434.4,147.923,436.088,150.031Z",
    transform: "translate(-18.552 -113.088)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2379",
    "data-name": "Path 2379",
    d: "M573.88,27.035c-.019.462-.337.533-.554.709-.714.58-1.654.795-2.309,1.477-.366.381-.649.06-.758-.268-.232-.7-1.521-1.139-.923-1.879a4.666,4.666,0,0,1,2.973-1.637C573.212,25.336,573.393,26.51,573.88,27.035Z",
    transform: "translate(-116.464 -26.137)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2380",
    "data-name": "Path 2380",
    d: "M415.764,118.731c.077.388-.234.477-.475.619-.579.34-1.147.7-1.741,1.014-.543.286-1.144.71-1.535-.211-.323-.76-1.03-1.553.22-2.167.429-.211.815-.507,1.236-.736C414.742,116.558,415.79,117.24,415.764,118.731Z",
    transform: "translate(-4.915 -90.91)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2381",
    "data-name": "Path 2381",
    d: "M584.056,43.97c.05.414-.257.6-.534.773a8.5,8.5,0,0,1-1.389.75c-.582.223-1.162,1.333-1.82.006-.5-1.007-.844-1.863.551-2.4a6.861,6.861,0,0,0,.888-.473A1.466,1.466,0,0,1,584.056,43.97Z",
    transform: "translate(-124.033 -38.125)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2382",
    "data-name": "Path 2382",
    d: "M418.482,75.692l.064-.12-.075.11Z",
    transform: "translate(-9.833 -61.614)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2383",
    "data-name": "Path 2383",
    d: "M583.351,118.692l-.067.121.08-.108Z",
    transform: "translate(-126.444 -92.123)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2384",
    "data-name": "Path 2384",
    d: "M496.813,94.889c-1.155-.21-3.219.082-3.76-1.035-.654-1.349.541-3.1.874-4.693.108-.515.592-.413.966-.328a14.212,14.212,0,0,1,3.694,1.239,2.587,2.587,0,0,1,1.612,3.056C499.923,94.308,498.843,94.912,496.813,94.889Z",
    transform: "translate(-62.466 -70.947)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2385",
    "data-name": "Path 2385",
    d: "M502.986,68.95c-.145,0-.29.008-.435,0-2.9-.173-3.022-.328-2.337-3.056s.682-2.715,3.366-1.721c.181.067.367.124.543.2,1.471.67,2.136,1.716,1.853,2.908S504.747,69,502.986,68.95Z",
    transform: "translate(-67.424 -53.118)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2020",
    "data-name": "Group 2020",
    transform: "translate(-14841.755 324.722)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -732.85, -332.04)",
    filter: "url(#Ellipse_173-6)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_173-16",
    "data-name": "Ellipse 173",
    cx: 66.24,
    cy: 66.24,
    r: 66.24,
    transform: "translate(732.76 331.75)",
    fill: "#22b7bb",
    stroke: "#fff",
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2317",
    "data-name": "Path 2317",
    d: "M979.128,117.669v-.241c.021-.046.06-.091.062-.137.015-.608,0-1.216.039-1.823.047-.826.089-1.655.2-2.474.184-1.341.37-2.686.65-4.009a39.158,39.158,0,0,1,5.4-13.113A40.1,40.1,0,0,1,1005.348,79.9a38.118,38.118,0,0,1,6.663-1.81c.841-.147,1.685-.279,2.532-.385.675-.085,1.355-.136,2.034-.174.941-.052,1.882-.1,2.824-.108.647-.009,1.3.028,1.943.072.951.065,1.9.142,2.852.239a34.143,34.143,0,0,1,4.259.739,40.034,40.034,0,0,1,27.574,22.892,38.207,38.207,0,0,1,2.534,7.97c.263,1.333.44,2.686.615,4.035.108.826.157,1.661.2,2.494.03.63.006,1.263,0,1.895-.006.608,0,1.216-.034,1.823-.048.846-.091,1.7-.206,2.533-.182,1.334-.368,2.672-.646,3.989a39.167,39.167,0,0,1-5.395,13.114,39.988,39.988,0,0,1-24.8,17.445,40.325,40.325,0,0,1-5.955.9c-.872.065-1.749.067-2.624.1a1.482,1.482,0,0,0-.231.045h-.4a1.928,1.928,0,0,0-.251-.045c-1.107-.059-2.216-.09-3.32-.179a26.1,26.1,0,0,1-2.72-.335c-1.41-.265-2.819-.55-4.2-.917a38.4,38.4,0,0,1-9.379-3.9,40.015,40.015,0,0,1-18.7-24.383,36.506,36.506,0,0,1-1.009-5.185c-.106-.907-.208-1.817-.267-2.728-.048-.739-.031-1.483-.047-2.224A.4.4,0,0,0,979.128,117.669Zm42.706-16.649V99.294a1.476,1.476,0,0,0-1.517-1.521q-1.174,0-2.349,0a1.248,1.248,0,0,0-.278.025,1.529,1.529,0,0,0-1.114,1.453q0,1.747,0,3.494c0,.169-.055.232-.225.254a8.628,8.628,0,0,0-.867.159,9.5,9.5,0,0,0-5.27,3.015,7.338,7.338,0,0,0-1.827,4.81,14.673,14.673,0,0,0,.118,1.916,6.557,6.557,0,0,0,.945,2.7,7.116,7.116,0,0,0,3.338,2.722,20.145,20.145,0,0,0,5.444,1.366,19.894,19.894,0,0,1,4.012.934,5.231,5.231,0,0,1,1.515.81,3.024,3.024,0,0,1,1.138,2.153,4.289,4.289,0,0,1-.515,2.727,4.767,4.767,0,0,1-2.926,2.133,7.655,7.655,0,0,1-2.618.26,9.917,9.917,0,0,1-2.366-.38,4.5,4.5,0,0,1-2.743-2.172,7.112,7.112,0,0,1-.615-1.775,1.239,1.239,0,0,0-1.248-1.018c-.916-.016-1.834-.021-2.751,0a1.2,1.2,0,0,0-1.221,1.509q.052.316.123.629a8.61,8.61,0,0,0,4.952,6.207,13,13,0,0,0,3.483,1.043c.279.045.279.045.279.341v3.654a1.223,1.223,0,0,0,.264.8,1.632,1.632,0,0,0,1.259.614c.736.018,1.472.005,2.209,0a1.476,1.476,0,0,0,1.527-1.532q0-1.767,0-3.533c0-.3,0-.3.289-.354a11.206,11.206,0,0,0,3.722-1.38,8.677,8.677,0,0,0,3.847-4.525,9.564,9.564,0,0,0,.378-4.725,6.574,6.574,0,0,0-3.779-5.255,18.366,18.366,0,0,0-5.536-1.542c-1.015-.155-2.033-.3-3.043-.488a7.832,7.832,0,0,1-2.432-.848,2.859,2.859,0,0,1-1.532-2.025,7.353,7.353,0,0,1-.1-1.315,3.281,3.281,0,0,1,.435-1.629,3.63,3.63,0,0,1,2.3-1.684,8.928,8.928,0,0,1,4.169-.106,4.266,4.266,0,0,1,2.68,1.6,5.936,5.936,0,0,1,.867,1.688,1.262,1.262,0,0,0,1.236.876q1.325,0,2.651,0a1.186,1.186,0,0,0,1.173-1.539,8.317,8.317,0,0,0-3.646-5.387,8.061,8.061,0,0,0-3.606-1.3c-.179-.02-.243-.068-.241-.252C1021.839,102.279,1021.834,101.649,1021.834,101.021Zm27.711,17.14c-.053-.911-.072-1.829-.169-2.737-.115-1.074-.252-2.149-.458-3.208a29.805,29.805,0,0,0-3.054-8.5,30.158,30.158,0,0,0-9.588-10.652,31.425,31.425,0,0,0-7.972-3.9.937.937,0,0,0-1.038.228,1.624,1.624,0,0,0-.489,1.108c0,.777.026,1.554-.009,2.329a2.309,2.309,0,0,0,1.387,1.977,22.261,22.261,0,0,1,5.193,2.675,20.847,20.847,0,0,1,3.563,2.98c.472.51.982.987,1.429,1.517a25.073,25.073,0,0,1,5.894,15.011,21.269,21.269,0,0,1-.036,2.486,28.76,28.76,0,0,1-.334,2.941,25.81,25.81,0,0,1-2.493,7.318,24.122,24.122,0,0,1-5.487,7.058,25.034,25.034,0,0,1-7.9,4.752,1.714,1.714,0,0,0-1.208,1.731c0,.8-.009,1.593,0,2.389a2.164,2.164,0,0,0,.122.624,1.139,1.139,0,0,0,1.267.715c.17-.057.333-.134.5-.194.535-.191,1.075-.369,1.606-.571a29.829,29.829,0,0,0,14.577-11.959,30.015,30.015,0,0,0,4.518-13.15C1049.472,120.144,1049.489,119.154,1049.545,118.16Zm-37.786-26.5h0a13.713,13.713,0,0,0-.011-1.561,1.144,1.144,0,0,0-1.506-.956q-.644.248-1.294.481a30.064,30.064,0,0,0-19.861,27,30.739,30.739,0,0,0,.077,3.546,34.211,34.211,0,0,0,.439,3.411,28.493,28.493,0,0,0,2.476,7.518,29.915,29.915,0,0,0,7.044,9.348,30.3,30.3,0,0,0,6.036,4.187,33.521,33.521,0,0,0,5.081,2.129.955.955,0,0,0,1.03-.183,1.6,1.6,0,0,0,.527-1.13c.009-.743,0-1.486,0-2.229a2.049,2.049,0,0,0-1.311-1.883,24.547,24.547,0,0,1-9.113-5.95,24.549,24.549,0,0,1-6.956-19.364,23.165,23.165,0,0,1,.412-2.951,25.372,25.372,0,0,1,4.793-10.49,24.6,24.6,0,0,1,5.273-5.018,25.6,25.6,0,0,1,5.736-3.022,1.566,1.566,0,0,0,1.121-1.384C1011.79,92.661,1011.758,92.158,1011.758,91.657Z",
    transform: "translate(-953.109 -51.617)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2021",
    "data-name": "Group 2021",
    transform: "translate(-15198.515 308.609)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -376.09, -315.93)",
    filter: "url(#Ellipse_173-7)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_173-17",
    "data-name": "Ellipse 173",
    cx: 66.24,
    cy: 66.24,
    r: 66.24,
    transform: "translate(376 315.64)",
    fill: "#22b7bb",
    stroke: "#fff",
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2342",
    "data-name": "Path 2342",
    d: "M2592.168,2745.857a112.453,112.453,0,0,1-.644,11.969,32.892,32.892,0,0,1-1.443,7.4,7.725,7.725,0,0,1-.452.977,1.291,1.291,0,0,1-1.544.726,11.942,11.942,0,0,1-1.911-.577,29.535,29.535,0,0,1-5.407-3.031q-4.076-2.815-8.066-5.753c-2.107-1.559-4.128-3.233-6.209-4.829a.916.916,0,0,1-.357-1.169,4.187,4.187,0,0,1,.633-1.171,6.27,6.27,0,0,1,3.176-1.941.98.98,0,0,1,1.13.353c.379.471.771.931,1.142,1.407a20.988,20.988,0,0,0,10.88,7.6,1.112,1.112,0,0,0,1.469-.66,12.272,12.272,0,0,0,1.017-3.7,49.849,49.849,0,0,0,.486-8.5,37.4,37.4,0,0,0-.816-7.957,10.59,10.59,0,0,0-.673-1.963c-.453-.994-.966-1.23-1.984-.861a15,15,0,0,0-2.439,1.134,64.632,64.632,0,0,0-8.1,5.823c-6.662,5.418-13.292,10.878-19.947,16.3a108.362,108.362,0,0,1-8.861,6.689,16.549,16.549,0,0,1-4.345,2.218,4.109,4.109,0,0,1-.525.126,1.984,1.984,0,0,1-2.333-1.081,11.194,11.194,0,0,1-1.2-3.442,53.367,53.367,0,0,1-1.027-8.6,118.7,118.7,0,0,1,.162-15.487c.146-1.919.42-3.828.621-5.743a23.528,23.528,0,0,1,1.077-5.078,8.216,8.216,0,0,1,.6-1.286,1.1,1.1,0,0,1,1.191-.614,9.214,9.214,0,0,1,1.822.453,32.789,32.789,0,0,1,6.093,3.376c4.888,3.223,9.511,6.8,14.06,10.482a.645.645,0,0,1,.3.727,4.7,4.7,0,0,1-.6,1.389,6.045,6.045,0,0,1-3.348,2.074.892.892,0,0,1-1-.318q-.991-1.207-1.985-2.411-.221-.267-.455-.524c-.4-.435-.592-.461-1.042-.095-1.346,1.095-2.711,2.169-4.023,3.3-1.614,1.4-3.179,2.847-4.773,4.265-.121.108-.344.242-.446.2a.611.611,0,0,1-.282-.438c-.107-1.112-.2-2.226-.259-3.341a.753.753,0,0,1,.238-.522q3.2-2.846,6.417-5.667c.058-.051.12-.1.178-.147.475-.406.462-.726-.053-1.068a20.26,20.26,0,0,0-4.291-2.168c-.434-.158-.874-.3-1.315-.443-.618-.2-1-.111-1.294.476a11.549,11.549,0,0,0-.845,2.22,28.431,28.431,0,0,0-.727,5.494,57.88,57.88,0,0,0,.071,8.13,22.822,22.822,0,0,0,1,5.679,6.9,6.9,0,0,0,.559,1.179,1.179,1.179,0,0,0,1.237.6,7.463,7.463,0,0,0,2.486-.788,39.178,39.178,0,0,0,6.032-3.792c5.542-4.061,10.758-8.528,16.057-12.891q6.475-5.332,13-10.6a28.854,28.854,0,0,1,5.786-3.738,9.3,9.3,0,0,1,1.785-.59,1.4,1.4,0,0,1,1.594.6,10.4,10.4,0,0,1,1,1.982,25.748,25.748,0,0,1,1.159,5.73A97.076,97.076,0,0,1,2592.168,2745.857Z",
    transform: "translate(-2496.752 -2680.103)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2007",
    "data-name": "Group 2007",
    transform: "translate(-15029.427 310.799)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -545.18, -318.12)",
    filter: "url(#Ellipse_173-8)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_173-18",
    "data-name": "Ellipse 173",
    cx: 93.836,
    cy: 93.836,
    r: 93.836,
    transform: "translate(545.09 317.83)",
    fill: "#22b7bb",
    stroke: "#fff",
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2052",
    "data-name": "Group 2052",
    transform: "translate(42.004 67.05)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2351",
    "data-name": "Path 2351",
    d: "M509.258,507.254q-.006-8.3-.008-16.6a1.931,1.931,0,0,0-.724-1.844q-15.117-11.266-30.185-22.592a4.049,4.049,0,0,0-.727-.31v1.735q0,18.739,0,37.48c0,.71-.052,1.421-.079,2.132H469.6q0-23.616-.016-47.235c0-2.187.494-4.085,2.582-5.1,2.1-1.021,3.972-.4,5.805.979q18.363,13.844,36.813,27.571a5.643,5.643,0,0,1,2.492,5.023c-.1,6.253-.068,12.507-.086,18.76Z",
    transform: "translate(-469.585 -454.307)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2352",
    "data-name": "Path 2352",
    d: "M548.693,507.285c-.027-2.354-.076-4.709-.078-7.065q-.013-16.275,0-32.549V466.1c-.653-.115-.911.307-1.244.557q-14.57,10.894-29.148,21.777a2.79,2.79,0,0,0-1.268,2.578c.061,5.423.02,10.848.016,16.272h-7.932q-.023-9.949-.041-19.9a4.236,4.236,0,0,1,1.915-3.466q19.05-14.273,38.118-28.522c2.757-2.054,5.58-1.072,7.6,2.489q0,24.122.027,48.244c0,.983-.193,1.223-1.186,1.183C553.213,507.221,550.952,507.285,548.693,507.285Z",
    transform: "translate(-453.167 -454.338)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2023",
    "data-name": "Group 2023",
    transform: "translate(-15304.862 95.584)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -269.74, -102.91)",
    filter: "url(#Ellipse_171-3)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_171-7",
    "data-name": "Ellipse 171",
    cx: 84.5,
    cy: 84.5,
    r: 84.5,
    transform: "translate(268.97 102.32)",
    fill: "#2f8bf7",
    stroke: "#fff",
    strokeWidth: 10
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2045",
    "data-name": "Group 2045",
    transform: "translate(-345.253 -12.265)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2310",
    "data-name": "Path 2310",
    d: "M478.767,105.533c-.575-.066-1.12-.12-1.662-.193a22.568,22.568,0,0,0-17.935,5.1c-.336.273-.681.538-1.039.78-.846.572-1.23.48-1.709-.445-.354-.683-.649-1.4-.986-2.089-2.1-4.319-5.168-7.618-9.908-8.982-5.336-1.535-10.4-1.019-14.946,2.426a22.24,22.24,0,0,0-6.228,7.95c-.185.365-.371.73-.582,1.081-.459.763-.784.825-1.5.266-.455-.355-.88-.75-1.323-1.121a20.771,20.771,0,0,0-18.261-5.028c-.3.055-.6.09-1.015.151.051-1.062.076-2.019.145-2.973a47.452,47.452,0,0,1,4.546-17.653,3.075,3.075,0,0,0,.086-2.637,64.252,64.252,0,0,1-4.266-18.727,37.186,37.186,0,0,1,.2-9.509,12.533,12.533,0,0,1,.79-2.617,2.467,2.467,0,0,1,3.112-1.557,16.417,16.417,0,0,1,7.067,3.634c2.732,2.32,5.333,4.794,7.975,7.22a8.294,8.294,0,0,1,1.02,1.215c1.781,2.417,3.526,3.054,6.417,2.192a39.846,39.846,0,0,1,15.217-1.492,45.056,45.056,0,0,1,10.087,2.091,1.439,1.439,0,0,0,1.9-.512c2.506-2.7,4.92-5.5,7.57-8.051A22.275,22.275,0,0,1,474.8,49.921c1.393-.272,1.975.037,2.535,1.368a19.182,19.182,0,0,1,1.207,8.5,64,64,0,0,1-2.168,11.914c-.807,3.368-1.734,6.708-2.646,10.05a4.561,4.561,0,0,0,.38,3.557,34.984,34.984,0,0,1,4.1,12.258c.334,2.452.432,4.937.628,7.407A3.017,3.017,0,0,1,478.767,105.533ZM406.688,55.577a3.715,3.715,0,0,0-.873.784,5.382,5.382,0,0,0-.531,1.485,17.659,17.659,0,0,0-.227,6.8,71.613,71.613,0,0,0,3.192,12.565c.08.232.364.535.568.548a1.063,1.063,0,0,0,.75-.4c.731-.922,1.369-1.921,2.125-2.82a42.12,42.12,0,0,1,8.086-7.479c.929-.65,1.048-1.12.4-1.807a39.663,39.663,0,0,0-11.983-9.133C407.759,55.92,407.292,55.793,406.688,55.577Zm68.017,5.416a9.5,9.5,0,0,0-.754-4.368c-.376-.939-.845-1.161-1.75-.822a17.618,17.618,0,0,0-1.841.827,45.1,45.1,0,0,0-10.418,7.936c-1.388,1.328-1.414,1.553.183,2.638a39.412,39.412,0,0,1,9.647,9.757c.23.316.762.775.937.695a1.884,1.884,0,0,0,.851-1.014c.392-1.084.686-2.2,1-3.313A45.005,45.005,0,0,0,474.705,60.994Zm-16.661,26.1.02-.1c.479-.04.958-.074,1.435-.121a2.69,2.69,0,0,0,2.281-4.01,4.939,4.939,0,0,0-9.315.89,2.035,2.035,0,0,0,1.607,2.739C455.378,86.778,456.719,86.9,458.045,87.093ZM422,87.01l3-.319a4,4,0,0,0,.428-.06,2.312,2.312,0,0,0,1.684-3.553,7.224,7.224,0,0,0-1.469-1.845c-2.961-2.734-6.493-.908-7.693,1.838a2.687,2.687,0,0,0,1.885,3.754C420.529,86.925,421.229,86.946,422,87.01Zm7.537,11.845c.144,0,.289,0,.433,0,.536.005,1.1.039,1.373-.556a1.349,1.349,0,0,0-.393-1.578,15.133,15.133,0,0,0-2.11-1.955,45.346,45.346,0,0,0-8.632-4.779,12.548,12.548,0,0,0-2.646-.627,1.093,1.093,0,0,0-1.185.758,4.247,4.247,0,0,0,1.526,5.294A24.714,24.714,0,0,0,429.539,98.855Zm35.193-6.764c-.061-.573-.09-1.152-.191-1.718a1.241,1.241,0,0,0-1.57-1.177,6.593,6.593,0,0,0-1.466.353,41.562,41.562,0,0,0-9.74,5.406,8.589,8.589,0,0,0-1.867,2.074,1.39,1.39,0,0,0-.176,1.227,1.544,1.544,0,0,0,1.181.566,23.863,23.863,0,0,0,12.114-3.491A3.129,3.129,0,0,0,464.733,92.09Z",
    transform: "translate(-11.413)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2311",
    "data-name": "Path 2311",
    d: "M403.368,182.191a24.374,24.374,0,0,1,6.554-.287,22.625,22.625,0,0,1,12.248,5.54c.294.249.579.509.88.749,1.172.934,1.921.809,2.7-.488.472-.783.9-1.6,1.326-2.4a17.869,17.869,0,0,1,6.727-7.275,15.267,15.267,0,0,1,21.269,6.511c.495.99.939,2.005,1.43,3,.7,1.408,1.363,1.6,2.592.623a30.786,30.786,0,0,1,6.529-4.226,22.8,22.8,0,0,1,12.937-1.566c.115.017.227.062.5.14-.321,1.044-.565,2.092-.96,3.079a33.032,33.032,0,0,1-11.083,14.065,52.055,52.055,0,0,1-15.367,7.841,31.2,31.2,0,0,1-11.047,1.865,31.715,31.715,0,0,1-7.844-1.542,53.532,53.532,0,0,1-23.985-14.828,22.282,22.282,0,0,1-5.371-10.245A3.544,3.544,0,0,1,403.368,182.191Zm45.876,17.644,2.739-4.265a.877.877,0,0,0,.067-.128c.369-.865.08-1.373-.855-1.416a11.367,11.367,0,0,0-1.584.074c-1.1.1-2.2.3-3.3.333a2.8,2.8,0,0,1-3.045-2.784,1.743,1.743,0,0,1,1.05-1.945c.363-.19.745-.345,1.09-.562,2.092-1.316,2.663-3.609,2.259-6.185a2.092,2.092,0,0,0-2.193-1.913c-2.336-.051-4.673-.039-7.01-.009a1.687,1.687,0,0,0-1.732,1.192c-.567,2.051-.465,4.641,1.779,6.14.778.52,1.6.975,2.429,1.419a1.615,1.615,0,0,1,.926,1.576,2.847,2.847,0,0,1-3.121,3.1c-1.149-.032-2.294-.229-3.44-.363a7.3,7.3,0,0,0-2.916.107l3.183,5.887.231-.062c.076-.64.18-1.278.217-1.92.032-.551-.028-1.107-.021-1.66a.765.765,0,0,1,.928-.837c.24.015.48.042.718.077a31.47,31.47,0,0,0,9,.041c2.066-.291,2.275-.107,2.057,1.994A2.659,2.659,0,0,0,449.244,199.835Zm-7.306-2.95v-.056c-.959,0-1.918-.008-2.876,0-.347,0-.729.058-.65.545a.956.956,0,0,0,1.284.531c.948-.533.975-.527,1.668.384.493.65.915.709,1.477.129a1.357,1.357,0,0,1,1.714-.45c.448.2.739-.115.82-.545.092-.489-.265-.542-.629-.543Q443.341,196.883,441.938,196.885Z",
    transform: "translate(-12.407 -74.194)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2312",
    "data-name": "Path 2312",
    d: "M389.471,103.981c1,3.169,2,6.3,2.976,9.445a5.312,5.312,0,0,1-.315,3.94,53.985,53.985,0,0,0-4.569,18.184,14.606,14.606,0,0,0,1.477,7.139,33.017,33.017,0,0,0,9.967,12.8,63.161,63.161,0,0,0,17.883,10.436,33.328,33.328,0,0,0,18.269,1.607c12.227-2.477,22.292-8.526,29.734-18.665a26.667,26.667,0,0,0,4.281-8.225,15.96,15.96,0,0,0,.52-6.932c-.471-3.137-1.005-6.27-1.667-9.372a24.841,24.841,0,0,0-2.75-7.038,4.786,4.786,0,0,1-.389-4.016c.774-2.5,1.473-5.034,2.168-7.562.209-.76.306-1.551.454-2.329l.243-.231a2.27,2.27,0,0,0,.2.527,41.974,41.974,0,0,1,7.409,18.147,43.55,43.55,0,0,1-1.565,18.286,46.5,46.5,0,0,1-7.082,14.926,45.368,45.368,0,0,1-25.8,17.448,47.415,47.415,0,0,1-23.726.2,46.153,46.153,0,0,1-33.6-33.991c-1.921-8.369-1.941-16.712.875-24.933a41.949,41.949,0,0,1,4.771-9.531A2.031,2.031,0,0,1,389.471,103.981Z",
    transform: "translate(0 -31.41)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2313",
    "data-name": "Path 2313",
    d: "M444.094,58.733c7.581-3.922,15.517-6.081,24.053-5.544a48.134,48.134,0,0,1,18.484,5.141c-.977.927-1.8,1.687-2.6,2.477a16.752,16.752,0,0,0-1.876,1.993,3.575,3.575,0,0,1-4.186,1.433,54.05,54.05,0,0,0-9.8-1.672,44.507,44.507,0,0,0-13.331,1.055c-.843.194-1.672.45-2.517.635a3.712,3.712,0,0,1-3.538-.728C447.187,62,445.693,60.378,444.094,58.733Z",
    transform: "translate(-36.316 -2.022)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2314",
    "data-name": "Path 2314",
    d: "M452.358,157.181a20.648,20.648,0,0,1-9.19-2.8,2.742,2.742,0,0,1-1.294-3.105,1.09,1.09,0,0,1,1.392-.92,9.11,9.11,0,0,1,1.928.572,31.045,31.045,0,0,1,7.572,4.42c.364.3,1,.651.664,1.2C453.2,156.921,452.582,157.058,452.358,157.181Z",
    transform: "translate(-34.953 -59.095)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2315",
    "data-name": "Path 2315",
    d: "M533.229,151.079a2.047,2.047,0,0,1-1.19,2.085,23.379,23.379,0,0,1-8.995,3.12c-.549.071-1.245.25-1.533-.437s.245-1.188.708-1.516c1.527-1.083,3.079-2.142,4.688-3.1,1.276-.758,2.646-1.358,3.982-2.01a3.537,3.537,0,0,1,.83-.237c.893-.185,1.3.115,1.42,1.034C533.176,150.306,533.189,150.595,533.229,151.079Z",
    transform: "translate(-81.718 -58.278)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XRP",
    transform: "translate(-15345.862 250.882)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -228.74, -258.21)",
    filter: "url(#Ellipse_171-4)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_171-8",
    "data-name": "Ellipse 171",
    cx: 82,
    cy: 82,
    r: 82,
    transform: "translate(227.97 257.32)",
    fill: "#2f8bf7",
    stroke: "#fff",
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1444",
    "data-name": "Group 1444",
    transform: "translate(40.901 48.886)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1590",
    "data-name": "Path 1590",
    d: "M212.352-17.484c1.145.748,2.286,1.5,3.436,2.244q3.189,2.065,6.388,4.124c2.763,1.781,5.5,3.578,8.3,5.337a17.131,17.131,0,0,0,8.179,2.446,18.36,18.36,0,0,0,11.338-2.65q8.76-5.635,17.487-11.292c.1-.065.191-.138.285-.208h11.381q-8.429,5.452-16.858,10.9c-2.415,1.561-4.795,3.148-7.265,4.672A26.07,26.07,0,0,1,244.15,1.663C236.6,2.512,230,1.2,224.5-2.281c-4.741-3-9.389-6.063-14.079-9.1q-4.723-3.055-9.45-6.107Z",
    transform: "translate(-200.895 17.484)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1591",
    "data-name": "Path 1591",
    d: "M199.489,448.421l1.6-1.035q5.307-3.432,10.615-6.864c3.957-2.557,7.88-5.138,11.885-7.663a25.957,25.957,0,0,1,11.211-3.672c7.542-.8,14.09.557,19.549,4.055,5.69,3.647,11.332,7.324,17,10.987q3.162,2.045,6.329,4.087a1.181,1.181,0,0,1,.116.1c-.148.006-.259.015-.369.015q-5.274,0-10.548-.006a1.205,1.205,0,0,1-.574-.15q-3.779-2.42-7.537-4.855c-3.523-2.273-7.022-4.563-10.582-6.811a17.014,17.014,0,0,0-8.226-2.428,18.278,18.278,0,0,0-11.208,2.662q-7.981,5.144-15.942,10.3c-.6.39-1.207.781-1.822,1.163a.844.844,0,0,1-.4.119q-5.431.009-10.861,0C199.673,448.435,199.626,448.43,199.489,448.421Z",
    transform: "translate(-199.489 -383.596)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Bitcoin",
    transform: "translate(-15016.978 168.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -557.63, -175.82)",
    filter: "url(#Ellipse_172-4)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_172-12",
    "data-name": "Ellipse 172",
    cx: 87.566,
    cy: 87.566,
    rx: 87.566,
    ry: 87.566,
    transform: "translate(557.63 175.82)",
    fill: "#2f8bf7",
    stroke: "#fff",
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1580",
    "data-name": "Path 1580",
    d: "M268.758,605.034A13.313,13.313,0,0,0,261.8,599.3a29.045,29.045,0,0,0-6.292-1.9,16.28,16.28,0,0,0,4.037-2.1,11.052,11.052,0,0,0,3.865-4.436,11.527,11.527,0,0,0,.867-5.37,13.431,13.431,0,0,0-3.27-8.531,21.114,21.114,0,0,0-9.314-5.142,44.372,44.372,0,0,0-11.271-1.695V557.964l-9.909,4.761v7.426h-7.927v-7.807l-10.157-4.38V570.15H190.85l6.936,9.141a14.312,14.312,0,0,1,4.335.438,3.1,3.1,0,0,1,1.61,1.142,7.166,7.166,0,0,1,.471,3.333v32.98a7.165,7.165,0,0,1-.471,3.313c-.322.5-.5.934-1.263,1.2s-.793.248-2.923.248h-.025l-8.67,9.139H212.4v12.186h10.156V631.082h7.927v12.186h9.909V631.006a61.717,61.717,0,0,0,14.715-1.962,25.121,25.121,0,0,0,11.073-6A15.722,15.722,0,0,0,270.1,613.3a16.857,16.857,0,0,0-1.338-8.264Zm-46.2-24.6h0v-.253h6.927c3.9,0,16.882-1,17.1,7.154s-17.1,7.818-17.1,7.818h-6.927v-.629h0Zm0,23.23h7.927c1.61,0,7.149.189,9.166.259a11.179,11.179,0,0,1,2.418.331c.285.074.555.158.847.251a14.041,14.041,0,0,1,3.416,1.329,6.731,6.731,0,0,1,1.766,1.276,7.357,7.357,0,0,1,1.617,2.662,6.251,6.251,0,0,1,.364,2.041,5.506,5.506,0,0,1-1.236,3.752,11.463,11.463,0,0,1-5.346,3.389,43.726,43.726,0,0,1-13.013,1.847h-7.927Z",
    transform: "translate(-142.93 -513.051)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2026",
    "data-name": "Group 2026",
    transform: "translate(-15458.32 127.324)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -116.28, -134.65)",
    filter: "url(#Ellipse_172-5)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_172-13",
    "data-name": "Ellipse 172",
    cx: 30.668,
    cy: 30.668,
    rx: 30.668,
    ry: 30.668,
    transform: "translate(116.28 134.65)",
    fill: "#2f8bf7",
    stroke: "#fff",
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2057",
    "data-name": "Group 2057",
    transform: "translate(-622.285 288.531)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2386",
    "data-name": "Path 2386",
    d: "M653.049-162.839a12.217,12.217,0,0,1-12.185-10.4,12.693,12.693,0,0,1,1.67-8.2c.27-.488.53-.51.987-.241,2.881,1.7,5.787,3.363,8.658,5.083a1.238,1.238,0,0,0,1.5.007c2.768-1.677,5.576-3.286,8.356-4.943.651-.388,1.059-.355,1.45.366a11.906,11.906,0,0,1,1.062,9.848,12.059,12.059,0,0,1-8.76,8.194A9.71,9.71,0,0,1,653.049-162.839Z",
    transform: "translate(0 -77.643)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2387",
    "data-name": "Path 2387",
    d: "M671.486-275.246c1.919,3.031,3.85,6.089,5.789,9.142.807,1.271,1.613,2.544,2.453,3.793.241.358.267.53-.142.765-2.489,1.432-4.973,2.875-7.438,4.349a1.323,1.323,0,0,1-1.535,0q-3.628-2.158-7.293-4.256c-.437-.251-.526-.475-.244-.912,1.649-2.553,3.279-5.118,4.916-7.679q1.576-2.466,3.156-4.929C671.221-275.089,671.258-275.248,671.486-275.246Zm5.745,12.645c-.119-.232-.227-.492-.377-.726-1.671-2.6-3.379-5.184-5-7.815-.462-.748-.655-.445-.96.036q-2.573,4.059-5.156,8.113c-.217.339-.3.518.14.766,1.646.938,3.269,1.919,4.893,2.9a1.083,1.083,0,0,0,1.239,0c1.6-.962,3.219-1.893,4.827-2.842C676.995-262.273,677.189-262.353,677.231-262.6Z",
    transform: "translate(-18.441 0)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2027",
    "data-name": "Group 2027",
    transform: "translate(-15310.207 58.118)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -264.4, -65.44)",
    filter: "url(#Ellipse_172-6)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_172-14",
    "data-name": "Ellipse 172",
    cx: 30.668,
    cy: 30.668,
    rx: 30.668,
    ry: 30.668,
    transform: "translate(264.4 65.44)",
    fill: "#2f8bf7",
    stroke: "#fff",
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2347",
    "data-name": "Path 2347",
    d: "M442.36,527.18c.009-3.3.394-6.529,2.273-9.356,1.756-2.64,4.161-4.239,7.46-3.754,6.079.894,11.776,2.821,16.528,6.885,3.081,2.635,4.384,5.959,3.293,10.01a4.53,4.53,0,0,1-3.35,3.515c-3.795,1.008-7.572,2.085-11.369,3.086a1.863,1.863,0,0,0-1.527,1.5,8.055,8.055,0,0,1-1.781,3.409c-1.974,2.234-4.527,2.326-6.64.235A14.305,14.305,0,0,1,444,536.775,29.688,29.688,0,0,1,442.36,527.18Zm11.266,8.835c-.248-2.188-.4-4.572-2.014-6.523-1.354-1.638-2.973-1.615-4.226.068-2.085,2.8-1.125,8.835,1.731,10.872a2.193,2.193,0,0,0,3.46-.577A6.782,6.782,0,0,0,453.626,536.016Zm3.208-13.441c-1.888-.049-2.076.2-1.592,2a18.531,18.531,0,0,1,.671,2.867c.105,1.027.535,1.3,1.5,1.167a38.7,38.7,0,0,0,7.744-1.543c.43-.151,1.044-.183,1.123-.689.075-.486-.445-.779-.828-1.028A17.807,17.807,0,0,0,456.833,522.575Z",
    transform: "translate(-426.658 -498.433)",
    fill: "#fbfafe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2028",
    "data-name": "Group 2028",
    transform: "translate(-15371.631 374.554)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -202.97, -381.88)",
    filter: "url(#Ellipse_231-2)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_231-7",
    "data-name": "Ellipse 231",
    cx: 30.712,
    cy: 30.712,
    rx: 30.712,
    ry: 30.712,
    transform: "translate(202.97 381.88)",
    fill: "#22b7bb",
    stroke: "#fff",
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("g", {
    id: "NEM-2",
    "data-name": "NEM",
    transform: "translate(18.034 17.442)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1728",
    "data-name": "Path 1728",
    d: "M16.744.841a7.207,7.207,0,0,0-4.712,5.88c-.062.4-.049.814-.077,1.221a6.038,6.038,0,0,1-4.689,5.536,6.144,6.144,0,0,1-6.42-2.549A8.067,8.067,0,0,1-.182,7.22C-.3,6.293-.32,5.354-.392,4.42A.716.716,0,0,1,0,3.646,25.723,25.723,0,0,1,16.565.725C16.605.732,16.64.773,16.744.841Z",
    transform: "translate(0.397 -0.398)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1729",
    "data-name": "Path 1729",
    d: "M75.367,24.974a8.852,8.852,0,0,0-.264-3,6.8,6.8,0,0,0-3.012-3.986,6.192,6.192,0,0,1-3.317-5.733,6.017,6.017,0,0,1,5.622-5.7A9.879,9.879,0,0,1,79.024,7.7c.219.1.43.214.643.325,1.822.946,1.57.427,1.436,2.617a24.986,24.986,0,0,1-4.561,12.934c-.26.374-.549.727-.83,1.086A3.923,3.923,0,0,1,75.367,24.974Z",
    transform: "translate(-55.244 -5.339)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1730",
    "data-name": "Path 1730",
    d: "M8.792,64.9A7.567,7.567,0,0,0,12.2,66.347a7.391,7.391,0,0,0,4.716-.866A6.056,6.056,0,0,1,24.7,66.949c1.872,2.236,1.865,6.124-.6,8.1a34.162,34.162,0,0,1-3.729,2.693.692.692,0,0,1-.837.019A25.5,25.5,0,0,1,9.383,66.5,4.6,4.6,0,0,1,8.792,64.9Z",
    transform: "translate(-6.995 -52.094)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2030",
    "data-name": "Group 2030",
    transform: "translate(-15097.353 301.272)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -477.25, -308.6)",
    filter: "url(#Ellipse_231-3)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_231-8",
    "data-name": "Ellipse 231",
    cx: 48.217,
    cy: 48.217,
    rx: 48.217,
    ry: 48.217,
    transform: "translate(477.25 308.6)",
    fill: "#22b7bb",
    stroke: "#fff",
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("g", {
    id: "NEM-3",
    "data-name": "NEM",
    transform: "translate(28.314 27.384)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1728-2",
    "data-name": "Path 1728",
    d: "M26.513,1.093a11.316,11.316,0,0,0-7.4,9.231c-.1.63-.077,1.278-.121,1.917a9.48,9.48,0,0,1-7.362,8.692,9.646,9.646,0,0,1-10.079-4C.355,15.173.2,13.118-.059,11.109c-.187-1.455-.217-2.93-.331-4.4A1.125,1.125,0,0,1,.22,5.5,40.386,40.386,0,0,1,26.234.912C26.3.922,26.351.986,26.513,1.093Z",
    transform: "translate(0.397 -0.398)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1729-2",
    "data-name": "Path 1729",
    d: "M79.126,35.481a13.9,13.9,0,0,0-.415-4.712,10.668,10.668,0,0,0-4.729-6.258c-3.413-2.071-5.3-4.958-5.208-9A9.447,9.447,0,0,1,77.6,6.556a15.51,15.51,0,0,1,7.267,1.8c.344.153.675.337,1.01.511,2.86,1.486,2.464.67,2.255,4.109a39.229,39.229,0,0,1-7.161,20.307c-.407.587-.862,1.142-1.3,1.706A6.161,6.161,0,0,1,79.126,35.481Z",
    transform: "translate(-47.533 -4.654)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1730-2",
    "data-name": "Path 1730",
    d: "M8.792,65.028a11.88,11.88,0,0,0,5.349,2.28,11.6,11.6,0,0,0,7.4-1.36,9.507,9.507,0,0,1,12.228,2.305c2.939,3.511,2.929,9.614-.941,12.712a53.634,53.634,0,0,1-5.855,4.229,1.087,1.087,0,0,1-1.314.03A40.039,40.039,0,0,1,9.72,67.542,7.226,7.226,0,0,1,8.792,65.028Z",
    transform: "translate(-5.971 -44.93)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2031",
    "data-name": "Group 2031",
    transform: "translate(-15218.658 138.083)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1528",
    "data-name": "Path 1528",
    d: "M502.939,536.271a18.891,18.891,0,0,0,8.218-.277c.414-.128.869-.414.828-.828a1,1,0,0,0-.186-.414,25.553,25.553,0,0,1-2.483-4.73.415.415,0,0,0-.153-.215.39.39,0,0,0-.265,0c-1.213.319-2.259,1.1-3.464,1.436a4.927,4.927,0,0,1-1.887.14c-.546-.062-1.291-.513-1.788-.455C502.041,532.737,502.728,534.425,502.939,536.271Z",
    transform: "translate(-357.218 -456.597)",
    fill: "#2f8bf7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1529",
    "data-name": "Path 1529",
    d: "M625.733,521.095c1.808-1.241,3.682-2.545,4.75-4.461a.775.775,0,0,0,.128-.385.8.8,0,0,0-.153-.372,15.372,15.372,0,0,0-3.861-4.167,11.267,11.267,0,0,0-2.152,1.986c-.456.48-1.713,1.241-1.726,1.974,0,.414.48.894.7,1.241.3.447.588.9.861,1.366A16.206,16.206,0,0,1,625.733,521.095Z",
    transform: "translate(-428.125 -446.002)",
    fill: "#2f8bf7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1530",
    "data-name": "Path 1530",
    d: "M490.882,546a1.841,1.841,0,0,1-.331,1.2,1.628,1.628,0,0,1-.7.414c-3.836,1.374-8.276-.339-12.1,1.014-.786.277-1.531.679-2.321.943a12.637,12.637,0,0,1-2.9.513c-1.353.128-2.714.211-4.072.248a9.782,9.782,0,0,1-3.07-.269,3.687,3.687,0,0,1-2.354-1.866,1.79,1.79,0,0,1-.116-1.328,1.432,1.432,0,0,1,.252-.414,3.627,3.627,0,0,1,.9-.732l1.411-.911a9.461,9.461,0,0,1,2.14-1.134c.558-.182,1.15-.261,1.717-.414,1.982-.579,3.5-2.152,4.9-3.662l1.92-2.048a1.929,1.929,0,0,1,.666-.534,1.845,1.845,0,0,1,.827-.079,11.065,11.065,0,0,1,5.235,1.755,6.778,6.778,0,0,0,1.291.761,4.609,4.609,0,0,0,3.608-.447c.492-.265.385-.414.592-.885s.712-.774,1.15-.343a1.217,1.217,0,0,1,.273.521,14.683,14.683,0,0,1,.257,4.266,1.876,1.876,0,0,0,.083.662,3.741,3.741,0,0,0,.377.612,1.426,1.426,0,0,1,.079.157,4.208,4.208,0,0,1,.277,2Z",
    transform: "translate(-334.406 -460.781)",
    fill: "#514e7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1531",
    "data-name": "Path 1531",
    d: "M490.882,556a1.843,1.843,0,0,1-.331,1.2,1.632,1.632,0,0,1-.7.414c-3.836,1.374-8.276-.339-12.1,1.014-.786.277-1.531.679-2.321.944a12.63,12.63,0,0,1-2.9.513c-1.353.128-2.714.211-4.072.249a9.78,9.78,0,0,1-3.07-.269,3.687,3.687,0,0,1-2.354-1.866,1.791,1.791,0,0,1-.116-1.328,1.429,1.429,0,0,1,.252-.414c.224.467.385,1.088.526,1.312a2.686,2.686,0,0,0,1.8,1.3,4.464,4.464,0,0,0,1.655-.211c3.476-.861,7.171-.873,10.51-2.177a24.291,24.291,0,0,1,3.443-1.324,27.043,27.043,0,0,1,3.724-.3c1.961-.157,3.861-.749,5.793-1.059a4.21,4.21,0,0,1,.261,2.011Z",
    transform: "translate(-334.406 -470.787)",
    fill: "#464353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1532",
    "data-name": "Path 1532",
    d: "M620.45,524.394a6.975,6.975,0,0,1-2.119,3.774,24.684,24.684,0,0,0-2.967,3.244c-.993,1.518-1.44,3.4-2.731,4.684a7.486,7.486,0,0,1-1.655,1.179,11.545,11.545,0,0,1-2.131.981,15.9,15.9,0,0,1-6.021.327,5.416,5.416,0,0,1-1.912-.368,5.758,5.758,0,0,1-.794-.488,3.794,3.794,0,0,1-1.242-1.241,1.242,1.242,0,0,1-.12-.9,2.116,2.116,0,0,1,.575-.877,13.656,13.656,0,0,1,1.457-1.312,8.736,8.736,0,0,0,1.9-1.655,5.353,5.353,0,0,0,.732-1.655,14.7,14.7,0,0,0,.534-3.166,10.043,10.043,0,0,1,.219-2.119c.306-1.092,1.117-2.069,1.026-3.2a.8.8,0,0,1,.042-.484.674.674,0,0,1,.381-.236,6.735,6.735,0,0,1,1.978-.459,2.3,2.3,0,0,1,1.837.72c.281.339.468.827.881.96a1.4,1.4,0,0,0,.629.025,5.269,5.269,0,0,0,2.9-.89,3.613,3.613,0,0,0,1.2-2.636c0-.377-.17-.77.414-.828.439-.058.786.414,1.009.7A9.8,9.8,0,0,1,618.4,522a1.042,1.042,0,0,1,.368-.07,1.6,1.6,0,0,1,1.32.675A2.628,2.628,0,0,1,620.45,524.394Z",
    transform: "translate(-414.057 -449.554)",
    fill: "#514e7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1533",
    "data-name": "Path 1533",
    d: "M620.671,530.2a6.971,6.971,0,0,1-2.119,3.774,24.669,24.669,0,0,0-2.967,3.245c-.993,1.518-1.44,3.4-2.731,4.684a7.5,7.5,0,0,1-1.655,1.179,11.543,11.543,0,0,1-2.131.981,15.9,15.9,0,0,1-6.021.327,5.41,5.41,0,0,1-1.912-.368,5.77,5.77,0,0,1-.795-.488A3.8,3.8,0,0,1,599.1,542.3a3.023,3.023,0,0,1,1.241-.3c.894.05,1.548.894,2.4,1.155,1.221.368,2.437-.493,3.675-.786a24.866,24.866,0,0,0,2.454-.414,6.065,6.065,0,0,0,1.816-1.1,9.255,9.255,0,0,0,1.941-1.87,12.028,12.028,0,0,0,1.138-2.272,32.472,32.472,0,0,1,2.3-4.4,3.121,3.121,0,0,1,.468-.612,6.4,6.4,0,0,1,.633-.459,4.811,4.811,0,0,0,1.461-2.665,4.681,4.681,0,0,1,.327-.89,1.6,1.6,0,0,1,1.32.674A2.627,2.627,0,0,1,620.671,530.2Z",
    transform: "translate(-414.279 -455.364)",
    fill: "#464353"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1545",
    "data-name": "Path 1545",
    d: "M383.962,372.323v-5.139a14.268,14.268,0,0,0-14.268-14.264H166.728a14.268,14.268,0,0,0-14.268,14.264v9.476Z",
    transform: "translate(-152.46 -352.92)",
    fill: "#33323d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_164",
    "data-name": "Ellipse 164",
    cx: 15.609,
    cy: 33.477,
    rx: 15.609,
    ry: 33.477,
    transform: "translate(177.283 4.892) rotate(-7.1)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1553",
    "data-name": "Path 1553",
    d: "M389.458,391.612V534.374a12.344,12.344,0,0,1-12.348,12.344H164.83a12.344,12.344,0,0,1-12.34-12.344V377.22c6.083,2.259,6.083,2.259,12.34,2.069H377.111A12.348,12.348,0,0,1,389.458,391.612Z",
    transform: "translate(-152.478 -367.165)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1554",
    "data-name": "Path 1554",
    d: "M389.458,396V538.758A12.348,12.348,0,0,1,377.111,551.1H164.83a12.344,12.344,0,0,1-12.34-12.344V381.6c6.083,2.255,6.083,2.255,12.34,2.069H377.111A12.348,12.348,0,0,1,389.458,396Z",
    transform: "translate(-152.478 -369.732)",
    fill: "#504f60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1555",
    "data-name": "Path 1555",
    d: "M628.626,543.937v45.655H584.35a22.829,22.829,0,1,1,0-45.657Z",
    transform: "translate(-392.25 -464.892)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1556",
    "data-name": "Path 1556",
    d: "M630.086,541v45.663H585.809a22.829,22.829,0,1,1,0-45.657Z",
    transform: "translate(-393.106 -463.172)",
    fill: "#33323d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_166",
    "data-name": "Ellipse 166",
    cx: 8.901,
    cy: 8.901,
    rx: 8.901,
    ry: 8.901,
    transform: "translate(185.926 92.973)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_167",
    "data-name": "Ellipse 167",
    cx: 8.901,
    cy: 8.901,
    rx: 8.901,
    ry: 8.901,
    transform: "translate(186.53 91.765)",
    fill: "#2f8bf7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "NEM-4",
    "data-name": "NEM",
    transform: "translate(-15193.788 88.743)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -380.82, -96.07)",
    filter: "url(#Ellipse_231-4)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_231-9",
    "data-name": "Ellipse 231",
    cx: 30.712,
    cy: 30.712,
    rx: 30.712,
    ry: 30.712,
    transform: "translate(380.82 96.07)",
    fill: "#22b7bb",
    stroke: "#fff",
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("g", {
    id: "NEM-5",
    "data-name": "NEM",
    transform: "translate(18.034 17.442)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1728-3",
    "data-name": "Path 1728",
    d: "M16.744.841a7.207,7.207,0,0,0-4.712,5.88c-.062.4-.049.814-.077,1.221a6.038,6.038,0,0,1-4.689,5.536,6.144,6.144,0,0,1-6.42-2.549A8.067,8.067,0,0,1-.182,7.22C-.3,6.293-.32,5.354-.392,4.42A.716.716,0,0,1,0,3.646,25.723,25.723,0,0,1,16.565.725C16.605.732,16.64.773,16.744.841Z",
    transform: "translate(0.397 -0.398)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1729-3",
    "data-name": "Path 1729",
    d: "M75.367,24.974a8.852,8.852,0,0,0-.264-3,6.8,6.8,0,0,0-3.012-3.986,6.192,6.192,0,0,1-3.317-5.733,6.017,6.017,0,0,1,5.622-5.7A9.879,9.879,0,0,1,79.024,7.7c.219.1.43.214.643.325,1.822.946,1.57.427,1.436,2.617a24.986,24.986,0,0,1-4.561,12.934c-.26.374-.549.727-.83,1.086A3.923,3.923,0,0,1,75.367,24.974Z",
    transform: "translate(-55.244 -5.339)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1730-3",
    "data-name": "Path 1730",
    d: "M8.792,64.9A7.567,7.567,0,0,0,12.2,66.347a7.391,7.391,0,0,0,4.716-.866A6.056,6.056,0,0,1,24.7,66.949c1.872,2.236,1.865,6.124-.6,8.1a34.162,34.162,0,0,1-3.729,2.693.692.692,0,0,1-.837.019A25.5,25.5,0,0,1,9.383,66.5,4.6,4.6,0,0,1,8.792,64.9Z",
    transform: "translate(-6.995 -52.094)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "USTD",
    transform: "translate(-15085.241 86.443)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -489.36, -93.77)",
    filter: "url(#Ellipse_173-9)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_173-19",
    "data-name": "Ellipse 173",
    cx: 41.176,
    cy: 41.176,
    r: 41.176,
    transform: "translate(489.27 93.47)",
    fill: "#22b7bb",
    stroke: "#fff",
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1583-2",
    "data-name": "Path 1583",
    d: "M86.336,58.519h0c-.21.016-1.294.08-3.713.08-1.924,0-3.29-.058-3.769-.08h0c-7.435-.327-12.985-1.621-12.985-3.171s5.55-2.842,12.985-3.174V57.23c.486.035,1.878.117,3.8.117,2.309,0,3.465-.1,3.673-.115V52.177c7.419.331,12.957,1.625,12.957,3.171s-5.536,2.84-12.957,3.169h0Zm0-6.865V47.13H96.691v-6.9H68.5v6.9H78.852v4.523c-8.414.387-14.742,2.053-14.742,4.051s6.328,3.662,14.742,4.051v14.5h7.482v-14.5c8.4-.387,14.713-2.052,14.713-4.047s-6.312-3.661-14.713-4.049h0Zm0,0Z",
    transform: "translate(-41.118 -15.576)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2034",
    "data-name": "Group 2034",
    transform: "translate(-14892.447 89.537)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -682.16, -96.86)",
    filter: "url(#Ellipse_172-7)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_172-15",
    "data-name": "Ellipse 172",
    cx: 68.455,
    cy: 68.455,
    rx: 68.455,
    ry: 68.455,
    transform: "translate(682.16 96.86)",
    fill: "#22b7bb",
    stroke: "#fff",
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2316",
    "data-name": "Path 2316",
    d: "M852.2,132.185v17.33a2.269,2.269,0,0,0,0,.28.476.476,0,0,1-.291.52c-1.221.688-2.435,1.39-3.648,2.093q-4.192,2.429-8.381,4.864l-16.811,9.766c-.493.287-1,.56-1.481.861a.558.558,0,0,1-.656.007c-1.4-.818-2.806-1.621-4.211-2.427l-9.676-5.549-14.757-8.464c-.676-.387-1.345-.787-2.029-1.159a.527.527,0,0,1-.308-.539q.011-8.743.006-17.486V114.767a1.52,1.52,0,0,0,0-.218.414.414,0,0,1,.273-.462c.474-.256.938-.536,1.406-.805l11.739-6.773,16-9.232c.468-.27.939-.534,1.4-.813a.512.512,0,0,1,.6-.012c2.956,1.714,5.92,3.414,8.88,5.121q5.532,3.193,11.06,6.392,5.3,3.061,10.612,6.108a.517.517,0,0,1,.271.532q-.005,6.935,0,13.871Zm-49.138,0c0,3.345,0,6.69-.007,10.035a.586.586,0,0,0,.341.587c1.507.858,3.007,1.729,4.508,2.6q6.459,3.734,12.916,7.473a.467.467,0,0,0,.539,0c1.263-.74,2.534-1.467,3.8-2.2q6.77-3.912,13.539-7.827c.46-.266.432-.189.432-.753q0-9.91,0-19.821c0-.572.034-.485-.457-.769q-4.745-2.747-9.493-5.489-3.911-2.26-7.82-4.523a.472.472,0,0,0-.54,0q-3.218,1.873-6.444,3.732l-9.467,5.471c-.54.312-1.077.628-1.62.933a.372.372,0,0,0-.229.4,2.262,2.262,0,0,1,0,.249Z",
    transform: "translate(-752.623 -63.731)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2035",
    "data-name": "Group 2035",
    transform: "translate(-14933.533 54.119)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -641.07, -61.44)",
    filter: "url(#Ellipse_173-10)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_173-20",
    "data-name": "Ellipse 173",
    cx: 41.176,
    cy: 41.176,
    r: 41.176,
    transform: "translate(640.98 61.15)",
    fill: "#22b7bb",
    stroke: "#fff",
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2053",
    "data-name": "Group 2053",
    transform: "translate(-245.73 -573.683)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2353",
    "data-name": "Path 2353",
    d: "M334.4,739.766a.48.48,0,0,0-.1-.031c-.988-.067-1.961-.245-2.938-.387a5.866,5.866,0,0,1-.691-.116,1.98,1.98,0,0,1-.539-.235.771.771,0,0,1-.306-.981c.029-.075.065-.147.1-.219l8.217-16.689c.035-.071.072-.142.12-.234l9.632,4.309c-.039.071-.065.123-.1.172-2.042,3.292-4.106,6.571-6.291,9.771-.694,1.016-1.41,2.016-2.183,2.975a4.385,4.385,0,0,1-3.126,1.623c-.071.007-.141.028-.212.042Z",
    transform: "translate(-50.61 -101.419)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2354",
    "data-name": "Path 2354",
    d: "M286.728,668.536c.032.366.063.708.091,1.049q.2,2.43.391,4.861.143,1.785.281,3.57.069.876.141,1.752c.015.182.009.208-.166.244a6,6,0,0,1-.779.128c-.891.067-1.782.14-2.675.173-4.774.177-9.551.177-14.327.129-.681-.007-1.362-.039-2.042-.074a4.133,4.133,0,0,1-1.263-.265,2.109,2.109,0,0,1-.661-.385,1.222,1.222,0,0,1-.426-.861c-.081-1.117-.177-2.234-.258-3.351-.057-.782-.1-1.564-.147-2.346-.025-.439-.04-.878-.049-1.317a2.768,2.768,0,0,1,.178-1.033,1.578,1.578,0,0,1,.371-.591,1.062,1.062,0,0,1,.7-.313c1.25-.077,2.5-.166,3.749-.25l2.148-.142,3.77-.253,2.214-.146,3.683-.249,2.1-.141,2.565-.171C286.45,668.546,286.575,668.543,286.728,668.536Z",
    transform: "translate(0 -60.618)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2355",
    "data-name": "Path 2355",
    d: "M330.243,602.988l-8.107,4.768L310.052,593.6c.1-.037.177-.068.256-.1q2.868-1.011,5.735-2.022c.552-.2,1.1-.395,1.647-.61a1.3,1.3,0,0,1,.921-.019,4.3,4.3,0,0,1,.979.491,14.042,14.042,0,0,1,1.854,1.477,44.921,44.921,0,0,1,3.2,3.3c1.916,2.151,3.723,4.391,5.469,6.681C330.152,602.855,330.192,602.915,330.243,602.988Z",
    transform: "translate(-35.247)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2356",
    "data-name": "Path 2356",
    d: "M412.239,634.6a.845.845,0,0,0,.018-.163q-.1-1.282-.2-2.563c-.081-1.015-.165-2.029-.246-3.044-.066-.825-.128-1.65-.192-2.475-.032-.416-.068-.832-.1-1.249a.362.362,0,0,0-.189-.313q-3.631-2.315-7.256-4.64l-.8-.51c-.061-.039-.12-.081-.187-.127a29.968,29.968,0,0,0,2.746-7.525.776.776,0,0,1,.13.035,11.648,11.648,0,0,1,5.088,4.383,8.376,8.376,0,0,1,1.235,4.929,11.6,11.6,0,0,1-.691,3.3c-.026.075-.051.15-.081.24.261.023.507.031.748.069.8.126,1.606.25,2.4.4a3.592,3.592,0,0,1,.821.3,1.635,1.635,0,0,1,.414.319.656.656,0,0,1,.194.432c.077,1,.151,2,.23,3q.113,1.435.233,2.869a2.789,2.789,0,0,1-.109,1.064,1.471,1.471,0,0,1-.32.57.85.85,0,0,1-.549.285c-1.068.13-2.134.277-3.2.416a.976.976,0,0,1-.151,0Z",
    transform: "translate(-107.783 -16.539)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2357",
    "data-name": "Path 2357",
    d: "M419.766,714.561a2.423,2.423,0,0,1,.7.771,7.112,7.112,0,0,1,.783,1.9,19.727,19.727,0,0,1,.582,3.192c.039.364.071.729.1,1.093a2.438,2.438,0,0,1-.382,1.55c-.211.325-.443.637-.685.939-.6.755-1.219,1.5-1.83,2.249a5.351,5.351,0,0,1-.966.955,1.979,1.979,0,0,1-.7.348.927.927,0,0,1-.915-.231,2.151,2.151,0,0,1-.388-.525c-.323-.615-.622-1.243-.936-1.863q-1.128-2.222-2.261-4.441c-.036-.071-.07-.142-.11-.224.083-.069.155-.13.228-.189q3.33-2.694,6.659-5.389a1.171,1.171,0,0,0,.127-.138Z",
    transform: "translate(-115.313 -96.497)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2036",
    "data-name": "Group 2036",
    transform: "translate(-14841.845 191.577)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -732.76, -198.9)",
    filter: "url(#Ellipse_231-5)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_231-10",
    "data-name": "Ellipse 231",
    cx: 30.712,
    cy: 30.712,
    rx: 30.712,
    ry: 30.712,
    transform: "translate(732.76 198.9)",
    fill: "#2f8bf7",
    stroke: "#fff",
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2338",
    "data-name": "Path 2338",
    d: "M2826.167,2516.493c2.1,0,4.213-.074,6.314.016a15.638,15.638,0,0,1,10.682,4.493,13.167,13.167,0,0,1,3.161,4.865.476.476,0,0,0,.508.341c1.01-.007,2.019,0,3.029,0,.354,0,.4.042.4.4q.005,1.335,0,2.67c0,.321-.092.41-.416.411-.761,0-1.523.008-2.285,0-.231,0-.307.084-.288.3a18.5,18.5,0,0,1,0,3.075c-.022.284.024.325.313.326h2.413c.315,0,.3.006.275.316s-.015.632-.016.949c0,.582,0,1.164,0,1.746,0,.378-.07.446-.453.447q-1.515,0-3.029,0c-.336,0-.439.061-.56.373a13.821,13.821,0,0,1-5.323,6.542,15.723,15.723,0,0,1-5.852,2.36,19.836,19.836,0,0,1-3.875.356q-5.8-.007-11.6,0c-.268,0-.32-.077-.319-.328q.013-4.441.005-8.881c0-.384-.01-.395-.385-.395h-3.491c-.319,0-.34-.02-.341-.356,0-.95.005-1.9-.005-2.849,0-.212.059-.277.274-.275,1.189.01,2.379.005,3.568,0,.354,0,.379-.025.38-.38,0-1,0-2,0-3,0-.247-.092-.329-.334-.327-1.181.008-2.362,0-3.542.009-.253,0-.351-.07-.348-.331q.015-1.425,0-2.849c0-.235.1-.29.306-.289,1.164.006,2.328,0,3.491,0,.391,0,.424-.032.424-.425q0-4.441,0-8.882c0-.434,0-.436.444-.436h6.469Zm6.452,9.808h9.6c.38,0,.435-.086.277-.444a3.564,3.564,0,0,0-.161-.32,10.871,10.871,0,0,0-2.606-3.135,11.766,11.766,0,0,0-7.509-2.718c-3.045-.019-6.09,0-9.135,0-.425,0-.441.016-.441.455q0,2.822,0,5.645c0,.521,0,.522.511.522Zm.012,10.592h-9.545c-.432,0-.446.015-.446.447q0,2.758,0,5.516c0,.569,0,.57.58.57,2.429,0,4.858-.011,7.287.005a21.719,21.719,0,0,0,3.216-.187,13.562,13.562,0,0,0,4.421-1.458,10.164,10.164,0,0,0,2.845-2.284,10.7,10.7,0,0,0,1.5-2.167c.192-.366.141-.46-.26-.461-.308,0-.615.018-.923.018Q2836.968,2536.894,2832.631,2536.893Zm.511-3.508h10.109c.387,0,.413-.024.441-.417a20.522,20.522,0,0,0,0-2.871c-.025-.362-.076-.41-.433-.41h-20.219c-.365,0-.4.033-.4.393q0,1.463,0,2.925c0,.379,0,.38.392.38Z",
    transform: "translate(-2801.949 -2500.76)",
    fill: "#fdfdfc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2015",
    "data-name": "Group 2015",
    transform: "translate(-14880.762 264.233)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -693.84, -271.56)",
    filter: "url(#Ellipse_172-8)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_172-16",
    "data-name": "Ellipse 172",
    cx: 56.77,
    cy: 56.769,
    rx: 56.77,
    ry: 56.769,
    transform: "translate(693.84 271.56)",
    fill: "#2f8bf7",
    stroke: "#fff",
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2048",
    "data-name": "Group 2048",
    transform: "translate(28.804 23.276)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2329",
    "data-name": "Path 2329",
    d: "M1738.77,71.485a2.362,2.362,0,0,0-.338-1.007c-.311-.545-.626-1.088-.959-1.62a13.017,13.017,0,0,1-1.229-2.266,9.28,9.28,0,0,1-.62-3.74,6.366,6.366,0,0,1,1.233-3.5c.475-.663.994-1.3,1.5-1.935a24.6,24.6,0,0,0,2.234-3.194,10.626,10.626,0,0,0,1.291-3.935,14.779,14.779,0,0,1,.465-2.427,5.044,5.044,0,0,1,1.1-1.981,4.814,4.814,0,0,0,.4-.505.931.931,0,0,0,.072-1.038c-.492-.926-.959-1.866-1.467-2.784q-2.489-4.5-5-8.98a3.813,3.813,0,0,1-.276-.582c.048.068.1.134.143.2q3.042,4.7,6.087,9.4c.538.827,1.109,1.633,1.67,2.444a2.3,2.3,0,0,0,1.506.952,1.707,1.707,0,0,0,.772-.039,8.624,8.624,0,0,0,1.147-.369,2.207,2.207,0,0,0,.624-.412.9.9,0,0,0,.157-1.26,4.237,4.237,0,0,0-.306-.409c-1.639-2.021-3.272-4.047-4.92-6.062q-7.081-8.659-14.171-17.31a9.986,9.986,0,0,1-.618-.821c.063.064.128.126.188.192q5.256,5.755,10.51,11.512,5.3,5.825,10.577,11.669c.241.266.48.534.722.8a.33.33,0,0,1,.115.259c-.028.376-.028.755-.079,1.127a2.8,2.8,0,0,1-.791,1.557,4.759,4.759,0,0,1-2.439,1.394c-.583.136-1.177.221-1.767.329a2.181,2.181,0,0,0-1.131.52,2.039,2.039,0,0,0-.627,1.192,8.952,8.952,0,0,0-.152,1.2A12.173,12.173,0,0,1,1743,55.124a16.166,16.166,0,0,0-.787,1.855,3.777,3.777,0,0,0,1.048,4.27,14.875,14.875,0,0,0,1.45,1.155,10.5,10.5,0,0,1,1.528,1.23,4.609,4.609,0,0,1,.547.729,1.976,1.976,0,0,1,.294,1.076c0,.278,0,.556-.005.834a2.531,2.531,0,0,1-.6,1.606,7.473,7.473,0,0,1-2.122,1.759A15.055,15.055,0,0,1,1740.7,71.1c-.509.136-1.026.245-1.542.358A2.525,2.525,0,0,1,1738.77,71.485Zm.977-7.865a1.277,1.277,0,0,0-1.5-1.29.647.647,0,0,0-.415.226.351.351,0,0,0,.087.536c.037.025.08.04.118.064a.309.309,0,0,1,.139.474c-.054.113-.125.218-.176.333a.565.565,0,0,0,.017.565.806.806,0,0,0,.8.33A1.27,1.27,0,0,0,1739.747,63.62Z",
    transform: "translate(-1729.27 -18.306)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2330",
    "data-name": "Path 2330",
    d: "M1847.721,111.007a1.667,1.667,0,0,1,.174.115,7.183,7.183,0,0,0,3.3,1.61c1,.217,2,.4,3,.566,1.57.26,3.153.45,4.694.865a12.224,12.224,0,0,1,4.124,1.9,8.574,8.574,0,0,1,3.5,5.6,8.462,8.462,0,0,1,.106,1.527,11.945,11.945,0,0,1-.19,2.222,9.206,9.206,0,0,1-.944,2.477,1.257,1.257,0,0,1-.136.163,3,3,0,0,1-.063-.346,5.144,5.144,0,0,0-1.966-3.745,12.112,12.112,0,0,0-2.494-1.578c-1.451-.727-2.953-1.337-4.455-1.944a32.915,32.915,0,0,1-4.51-2.142,10.909,10.909,0,0,1-2.633-2.072,5.821,5.821,0,0,1-1.52-3.6c-.029-.456-.019-.913-.022-1.37A1.926,1.926,0,0,1,1847.721,111.007Z",
    transform: "translate(-1813.674 -84.381)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2331",
    "data-name": "Path 2331",
    d: "M1825.138,74.6a1.519,1.519,0,0,1,.155.131,13.392,13.392,0,0,1,2.965,5.188c.124.426.182.871.271,1.307l-.059.024c-.094-.139-.19-.277-.283-.416a5.064,5.064,0,0,0-2.233-1.919,6.1,6.1,0,0,0-1.817-.454c-.918-.091-1.839-.147-2.759-.226-.982-.084-1.966-.154-2.944-.272a14.052,14.052,0,0,1-3.854-1.028,9.444,9.444,0,0,1-3.12-2.252,39.559,39.559,0,0,1-2.835-3.45,31.4,31.4,0,0,0-2.9-3.432,11.773,11.773,0,0,0-3.566-2.509,10.8,10.8,0,0,0-2.782-.787,1.365,1.365,0,0,1-.434-.126c.173-.009.347-.028.52-.026a10.408,10.408,0,0,1,3.91.733,11.682,11.682,0,0,1,3.028,1.88,18.8,18.8,0,0,1,2.459,2.482.5.5,0,0,0,.527.2c.583-.095,1.168-.176,1.755-.248a7.554,7.554,0,0,1,.965-.068c.816.006,1.635-.012,2.447.058a16.073,16.073,0,0,1,7.508,2.535.885.885,0,0,1,.424.615,8.385,8.385,0,0,1,.155,2.647,3.751,3.751,0,0,1-.381,1.254c-.053.1-.11.206-.155.313a.956.956,0,0,0,.258,1.078.931.931,0,0,0,1.1.117,1.961,1.961,0,0,0,.615-.594,5.576,5.576,0,0,0,.791-1.757c.078-.276.14-.556.211-.834C1825.093,74.72,1825.113,74.672,1825.138,74.6Z",
    transform: "translate(-1778.934 -51.128)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2332",
    "data-name": "Path 2332",
    d: "M1869.45,146.065c.148.077.244.124.337.176,1.124.635,2.243,1.277,3.371,1.9a28.111,28.111,0,0,1,3.128,1.944,9.386,9.386,0,0,1,2.4,2.478,7.778,7.778,0,0,1,1.209,3.747,10.141,10.141,0,0,1-.177,2.919,9.192,9.192,0,0,1-5,6.5c-.068.034-.141.057-.277.112.108-.244.186-.431.273-.613a6.9,6.9,0,0,0,.63-2.075,6.463,6.463,0,0,0-.259-2.71,10.417,10.417,0,0,0-1.224-2.6c-.785-1.244-1.6-2.466-2.412-3.695a25.3,25.3,0,0,1-1.411-2.289,8.513,8.513,0,0,1-.93-2.987,6.478,6.478,0,0,1,.161-2.376A3.844,3.844,0,0,1,1869.45,146.065Z",
    transform: "translate(-1828.914 -109.37)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2333",
    "data-name": "Path 2333",
    d: "M1787.181,189.922c.25-.236.453-.451.679-.638a17.781,17.781,0,0,1,6.6-3.5,10.52,10.52,0,0,1,2.948-.385,8.614,8.614,0,0,1,4.076.916,9.751,9.751,0,0,1,1.116.7,5.931,5.931,0,0,1,2.064,2.953,15.391,15.391,0,0,1,.591,2.592c.121.725.23,1.452.381,2.171a4.5,4.5,0,0,0,.707,1.617,2.838,2.838,0,0,0,2.065,1.216,6.109,6.109,0,0,0,2.826-.353c.178-.059.355-.123.533-.182.013,0,.032.008.05.012,0,.016,0,.038-.013.046a6.165,6.165,0,0,1-2.3,1.193,4.288,4.288,0,0,1-4.416-1.351,6.861,6.861,0,0,1-1.142-1.72c-.283-.61-.55-1.228-.843-1.833s-.573-1.2-.909-1.769a5.174,5.174,0,0,0-2.674-2.276,3.576,3.576,0,0,0-2.827.027,2.387,2.387,0,0,0-1.487,2.219,2.118,2.118,0,0,0,.683,1.67,2.93,2.93,0,0,0,2,.866,1.926,1.926,0,0,0,1.889-1.537,2.255,2.255,0,0,0,.039-.667,1.7,1.7,0,0,0-1.539-1.484,1.681,1.681,0,0,0-1,.142,1.145,1.145,0,0,0-.642,1.2.815.815,0,0,0,.342.587c.073.052.149.1.226.149a.748.748,0,0,1-.532-.369,1.152,1.152,0,0,1-.073-1.108,1.494,1.494,0,0,1,1.226-.934,2.421,2.421,0,0,1,1.92.508,2.064,2.064,0,0,1,.752,1.574,2.736,2.736,0,0,1-2.334,3,3.682,3.682,0,0,1-2.817-.709,13.994,13.994,0,0,1-1.3-1.171c-.431-.406-.845-.83-1.276-1.236a6.992,6.992,0,0,0-3.665-1.794C1788.5,190.152,1787.87,190.043,1787.181,189.922Z",
    transform: "translate(-1770.548 -137.408)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2334",
    "data-name": "Path 2334",
    d: "M1798.039,69.466a7.073,7.073,0,0,1,2.262.795,3.867,3.867,0,0,1,1.7,1.953,13.7,13.7,0,0,1,.685,2.345c.127.568.243,1.14.4,1.7a5.488,5.488,0,0,0,.423,1.071c.277.522.6,1.018.9,1.526a2.39,2.39,0,0,1,.151.254c.113.255.024.437-.251.456a3.126,3.126,0,0,1-.774-.027,4.1,4.1,0,0,1-1.45-.619,7.76,7.76,0,0,1-2.645-2.778,11.937,11.937,0,0,1-1.462-4.441,8.05,8.05,0,0,1,0-1.96C1797.994,69.653,1798.017,69.568,1798.039,69.466Z",
    transform: "translate(-1778.204 -54.772)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2335",
    "data-name": "Path 2335",
    d: "M1828.087,141.541a5.945,5.945,0,0,1,1.341,2.526,1.571,1.571,0,0,1,.046.319,9.272,9.272,0,0,1-.035,2.095,4.635,4.635,0,0,1-.727,1.753,6.236,6.236,0,0,1-3.4,2.58,10.068,10.068,0,0,1-2.468.5c-.948.064-1.9.136-2.843.211a18.43,18.43,0,0,0-4.355.753l-.529.174-.033-.056c.072-.051.142-.106.218-.152a11.387,11.387,0,0,1,3.781-1.555c1.15-.228,2.3-.436,3.456-.649a10.964,10.964,0,0,0,2.681-.749,5.731,5.731,0,0,0,2.783-2.515,5.226,5.226,0,0,0,.584-2.755,7.924,7.924,0,0,0-.44-2.262C1828.126,141.705,1828.117,141.653,1828.087,141.541Z",
    transform: "translate(-1790.434 -106.145)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2336",
    "data-name": "Path 2336",
    d: "M1805.592,124.115c-.315-.03-.566-.038-.812-.081a1.111,1.111,0,0,1-.959-.953,2.677,2.677,0,0,1,1.088-2.789,1.725,1.725,0,0,1,1.147-.385,6.479,6.479,0,0,1,.748.053,2.54,2.54,0,0,1,1.988,1.622,1.291,1.291,0,0,1-.433,1.674,3.641,3.641,0,0,1-1.659.717C1806.315,124.045,1805.922,124.074,1805.592,124.115Zm.658-2.047a1.966,1.966,0,0,0,1.053-.281.716.716,0,0,0,.032-1.289,1.6,1.6,0,0,0-1.2-.276,1.305,1.305,0,0,0-.933.524.634.634,0,0,0,.091.894A1.551,1.551,0,0,0,1806.25,122.068Z",
    transform: "translate(-1782.367 -90.724)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2337",
    "data-name": "Path 2337",
    d: "M1873.19,79.232a4.411,4.411,0,0,0,.29-1.9,17.1,17.1,0,0,0-.1-2.176,2.893,2.893,0,0,0-1.239-2.144,16.344,16.344,0,0,0-1.4-.861c-.525-.288-1.073-.537-1.612-.8a1.434,1.434,0,0,1-.326-.194.841.841,0,0,1,.135.013,20.259,20.259,0,0,1,2.6.855c.256.1.518.2.782.282.321.1.416.048.46-.279.051-.373.059-.751.105-1.124.063-.515.125-1.032.225-1.541a4.713,4.713,0,0,1,.53-1.329c-.087.34-.184.656-.245.979a6.3,6.3,0,0,0-.033,1.691c.027.339.094.674.148,1.011a2.955,2.955,0,0,0,.737,1.559c.423.464.86.915,1.285,1.378.486.529.966,1.063,1.445,1.6.1.113.192.235.288.353l-.035.041c-.068-.06-.134-.123-.2-.181-.654-.532-1.306-1.067-1.965-1.592a3.669,3.669,0,0,0-.521-.331.254.254,0,0,0-.392.088.565.565,0,0,0-.1.242,4.207,4.207,0,0,0-.048.589,10.171,10.171,0,0,1-.219,2.352A4.439,4.439,0,0,1,1873.19,79.232Z",
    transform: "translate(-1828.731 -53.749)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockchianWallets);
export default __webpack_public_path__ + "static/media/blockchianWallets.a47f4f264c258d8f1ad03431cd21afae.svg";
export { ForwardRef as ReactComponent };